export default {
  abi: [
    {
      inputs: [
        {
          internalType: 'address',
          name: '_rdaoAddress',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_usdtAddress',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_verificationAddress',
          type: 'address',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Paused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'RedemptionApproved',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'daoTokenAmount',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'usdtAmount',
          type: 'uint256',
        },
      ],
      name: 'RedemptionFinalized',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'RedemptionRejected',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'daoTokenAmount',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'usdtAmount',
          type: 'uint256',
        },
      ],
      name: 'RedemptionSubmitted',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Unpaused',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'user',
          type: 'address',
        },
      ],
      name: 'approveRedemption',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'finalizeRedemption',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'user',
          type: 'address',
        },
      ],
      name: 'getStatus',
      outputs: [
        {
          components: [
            {
              internalType: 'uint256',
              name: 'tokenAmt',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'usdtAmt',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'status',
              type: 'uint256',
            },
          ],
          internalType: 'struct Redemption.RedemptionSubmission',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paused',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'daoTokenAmount',
          type: 'uint256',
        },
      ],
      name: 'redeemToken',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'user',
          type: 'address',
        },
      ],
      name: 'rejectRedemption',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ],
  bytecode: {
    object:
      '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',
    sourceMap:
      '510:4069:44:-:0;;;1228:279;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;936:32:19;719:10:32;936:18:19;:32::i;:::-;1006:5:24;996:15;;-1:-1:-1;;;;996:15:24;;;1354:5:44;:38;;-1:-1:-1;;;;;1354:38:44;;;-1:-1:-1;;;;;;1354:38:44;;;;;;;1402:5;:38;;;;;;;;;;;;;;;996:15:24;1450:50:44;;;;;;;;;;;510:4069;;2426:187:19;2499:16;2518:6;;-1:-1:-1;;;;;2534:17:19;;;-1:-1:-1;;;;;;2534:17:19;;;;;;2566:40;;2518:6;;;;;;;2566:40;;2499:16;2566:40;2489:124;2426:187;:::o;14:177:48:-;93:13;;-1:-1:-1;;;;;135:31:48;;125:42;;115:70;;181:1;178;171:12;115:70;14:177;;;:::o;196:378::-;284:6;292;300;353:2;341:9;332:7;328:23;324:32;321:52;;;369:1;366;359:12;321:52;392:40;422:9;392:40;:::i;:::-;382:50;;451:49;496:2;485:9;481:18;451:49;:::i;:::-;441:59;;519:49;564:2;553:9;549:18;519:49;:::i;:::-;509:59;;196:378;;;;;:::o;:::-;510:4069:44;;;;;;',
    linkReferences: {},
  },
  deployedBytecode: {
    object:
      '0x608060405234801561001057600080fd5b50600436106100935760003560e01c8063711a5c8611610066578063711a5c861461010c578063715018a61461011f5780638da5cb5b1461012757806392dd9f8814610142578063f2fde38b1461015557600080fd5b8063013054c21461009857806330ccebb5146100ad57806356cee8ab146100e75780635c975abb146100ef575b600080fd5b6100ab6100a6366004610b02565b610168565b005b6100c06100bb366004610b1b565b610309565b60408051825181526020808401519082015291810151908201526060015b60405180910390f35b6100ab61036f565b600054600160a01b900460ff1660405190151581526020016100de565b6100ab61011a366004610b1b565b610818565b6100ab610948565b6000546040516001600160a01b0390911681526020016100de565b6100ab610150366004610b1b565b61095c565b6100ab610163366004610b1b565b6109df565b6001546040516316591e6160e21b81523360048201526024810183905282916001600160a01b031690635964798490604401602060405180830381865afa1580156101b7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101db9190610b4b565b61022c5760405162461bcd60e51b815260206004820152601860248201527f5472616e73616374696f6e206973206e6f742076616c6964000000000000000060448201526064015b60405180910390fd5b336000908152600460205260409020600201541561028c5760405162461bcd60e51b815260206004820152601e60248201527f526564656d7074696f6e20616c726561647920696e2070726f677265737300006044820152606401610223565b6040805160608101825283815260208082018481526001838501818152336000818152600486528790209551865592519185019190915551600290930192909255825185815290810184905290917fb3a4f2e02befe5c50f8f6de1fa373cc36fe0a3b215d7104cb0feeb5c3b20c150910160405180910390a25050565b61032d60405180606001604052806000815260200160008152602001600081525090565b506001600160a01b0316600090815260046020908152604091829020825160608101845281548152600182015492810192909252600201549181019190915290565b336000908152600460205260409020600290810154146103dc5760405162461bcd60e51b815260206004820152602260248201527f546f6b656e20726564656d7074696f6e206177616974696e6720617070726f76604482015261185b60f21b6064820152608401610223565b336000908152600460208190526040918290206001015460035492516370a0823160e01b81523092810192909252916001600160a01b0316906370a0823190602401602060405180830381865afa15801561043b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061045f9190610b6d565b10156104bb5760405162461bcd60e51b815260206004820152602560248201527f496e73756666696369656e7420555344542062616c616e6365206f6e20636f6e6044820152641d1c9858dd60da1b6064820152608401610223565b60018054336000818152600460208190526040918290209094015490516316591e6160e21b81529384019190915260248301526001600160a01b031690635964798490604401602060405180830381865afa15801561051e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105429190610b4b565b61058e5760405162461bcd60e51b815260206004820152601d60248201527f4661696c656420746f2066696e616c697a6520726564656d7074696f6e0000006044820152606401610223565b6003543360008181526004602081905260409182902060010154915163a9059cbb60e01b81529081019290925260248201526001600160a01b039091169063a9059cbb906044016020604051808303816000875af11580156105f4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106189190610b4b565b61065b5760405162461bcd60e51b81526020600482015260146024820152731554d115081d1c985b9cd9995c8819985a5b195960621b6044820152606401610223565b600254336000818152600460208190526040918290205491516323b872dd60e01b81529081019290925230602483015260448201526001600160a01b03909116906323b872dd906064016020604051808303816000875af11580156106c4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106e89190610b4b565b61072b5760405162461bcd60e51b815260206004820152601460248201527314911053c81d1c985b9cd9995c8819985a5b195960621b6044820152606401610223565b3360008181526004602052604090819020805460019091015491517ffec12f632c814860c9f166795deb25cba0668e2cbfa82b36e8f8721791f6284992610779928252602082015260400190565b60405180910390a260018054336000818152600460208190526040918290209094015490516398368b2560e01b81529384019190915260248301526001600160a01b0316906398368b2590604401600060405180830381600087803b1580156107e157600080fd5b505af11580156107f5573d6000803e3d6000fd5b505033600090815260046020526040812060028101829055818155600101555050565b610820610a58565b6001600160a01b03811660009081526004602052604081206002015490036108955760405162461bcd60e51b815260206004820152602260248201527f526564656d7074696f6e206e6f20726564656d7074696f6e2072657175657374604482015261195960f21b6064820152608401610223565b6001600160a01b038116600090815260046020526040902060029081015490036109015760405162461bcd60e51b815260206004820152601b60248201527f526564656d7074696f6e20616c726561647920617070726f76656400000000006044820152606401610223565b6001600160a01b038116600081815260046020526040808220600290810155517fc2f3d6c38501c14087e8da7ae42f7038ba996a2e0a9a0e97ea99cad99f03621e9190a250565b610950610a58565b61095a6000610ab2565b565b6000546001600160a01b031633148061097d5750336001600160a01b038216145b6109b85760405162461bcd60e51b815260206004820152600c60248201526b155b985d5d1a1bdc9a5e995960a21b6044820152606401610223565b6001600160a01b031660009081526004602052604081206002810182905581815560010155565b6109e7610a58565b6001600160a01b038116610a4c5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610223565b610a5581610ab2565b50565b6000546001600160a01b0316331461095a5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610223565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b600060208284031215610b1457600080fd5b5035919050565b600060208284031215610b2d57600080fd5b81356001600160a01b0381168114610b4457600080fd5b9392505050565b600060208284031215610b5d57600080fd5b81518015158114610b4457600080fd5b600060208284031215610b7f57600080fd5b505191905056fea26469706673582212208d5c66cccdf92c87e16e89fedc3c5be9cef4b5315eae0accaf266fdee72ae52a64736f6c63430008170033',
    sourceMap:
      '510:4069:44:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1668:641;;;;;;:::i;:::-;;:::i;:::-;;1513:149;;;;;;:::i;:::-;;:::i;:::-;;;;732:13:48;;714:32;;802:4;790:17;;;784:24;762:20;;;755:54;853:17;;;847:24;825:20;;;818:54;702:2;687:18;1513:149:44;;;;;;;;3020:1557;;;:::i;1615:84:24:-;1662:4;1685:7;-1:-1:-1;;;1685:7:24;;;;1615:84;;1048:14:48;;1041:22;1023:41;;1011:2;996:18;1615:84:24;883:187:48;2315:410:44;;;;;;:::i;:::-;;:::i;1824:101:19:-;;;:::i;1201:85::-;1247:7;1273:6;1201:85;;-1:-1:-1;;;;;1273:6:19;;;1221:51:48;;1209:2;1194:18;1201:85:19;1075:203:48;2731:283:44;;;;;;:::i;:::-;;:::i;2074:198:19:-;;;;;;:::i;:::-;;:::i;1668:641:44:-;1793:13;;:42;;-1:-1:-1;;;1793:42:44;;1815:10;1793:42;;;1457:51:48;1524:18;;;1517:34;;;1748:14:44;;-1:-1:-1;;;;;1793:13:44;;:21;;1430:18:48;;1793:42:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1772:113;;;;-1:-1:-1;;;1772:113:44;;2046:2:48;1772:113:44;;;2028:21:48;2085:2;2065:18;;;2058:30;2124:26;2104:18;;;2097:54;2168:18;;1772:113:44;;;;;;;;;1940:10;1917:34;;;;:22;:34;;;;;:41;;;:46;1896:123;;;;-1:-1:-1;;;1896:123:44;;2399:2:48;1896:123:44;;;2381:21:48;2438:2;2418:18;;;2411:30;2477:32;2457:18;;;2450:60;2527:18;;1896:123:44;2197:354:48;1896:123:44;2081:139;;;;;;;;;;;;;;;;;;2204:1;2081:139;;;;;;2053:10;-1:-1:-1;2030:34:44;;;:22;:34;;;;;:200;;;;;;;;;;;;;;;;;;;;;;2246:56;;2730:25:48;;;2771:18;;;2764:34;;;2053:10:44;;2246:56;;2703:18:48;2246:56:44;;;;;;;1720:589;1668:641;:::o;1513:149::-;1581:27;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;1581:27:44;-1:-1:-1;;;;;;1627:28:44;;;;;:22;:28;;;;;;;;;1620:35;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1513:149::o;3020:1557::-;3111:10;3088:34;;;;:22;:34;;;;;:41;;;;;:46;3067:127;;;;-1:-1:-1;;;3067:127:44;;3011:2:48;3067:127:44;;;2993:21:48;3050:2;3030:18;;;3023:30;3089:34;3069:18;;;3062:62;-1:-1:-1;;;3140:18:48;;;3133:32;3182:19;;3067:127:44;2809:398:48;3067:127:44;3299:10;3276:34;;;;:22;:34;;;;;;;;;:42;;;3226:5;;:30;;-1:-1:-1;;;3226:30:44;;3250:4;3226:30;;;1221:51:48;;;;3276:42:44;-1:-1:-1;;;;;3226:5:44;;:15;;1194:18:48;;3226:30:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:92;;3205:176;;;;-1:-1:-1;;;3205:176:44;;3603:2:48;3205:176:44;;;3585:21:48;3642:2;3622:18;;;3615:30;3681:34;3661:18;;;3654:62;-1:-1:-1;;;3732:18:48;;;3725:35;3777:19;;3205:176:44;3401:401:48;3205:176:44;3413:13;;;3452:10;3413:13;3480:34;;;:22;:34;;;;;;;;;:42;;;;3413:123;;-1:-1:-1;;;3413:123:44;;;;;1457:51:48;;;;1524:18;;;1517:34;-1:-1:-1;;;;;3413:13:44;;:21;;1430:18:48;;3413:123:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;3392:199;;;;-1:-1:-1;;;3392:199:44;;4009:2:48;3392:199:44;;;3991:21:48;4048:2;4028:18;;;4021:30;4087:31;4067:18;;;4060:59;4136:18;;3392:199:44;3807:353:48;3392:199:44;3623:5;;3655:10;3623:5;3683:34;;;:22;:34;;;;;;;;;3623:5;3683:42;;3623:116;;-1:-1:-1;;;3623:116:44;;;;;1457:51:48;;;;1524:18;;;1517:34;-1:-1:-1;;;;;3623:5:44;;;;:14;;1430:18:48;;3623:116:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;3602:183;;;;-1:-1:-1;;;3602:183:44;;4367:2:48;3602:183:44;;;4349:21:48;4406:2;4386:18;;;4379:30;-1:-1:-1;;;4425:18:48;;;4418:50;4485:18;;3602:183:44;4165:344:48;3602:183:44;3883:5;;3919:10;3883:5;3978:34;;;:22;:34;;;;;;;;;:43;3883:152;;-1:-1:-1;;;3883:152:44;;;;;4754:34:48;;;;3955:4:44;4804:18:48;;;4797:43;4856:18;;;4849:34;-1:-1:-1;;;;;3883:5:44;;;;:18;;4689::48;;3883:152:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;3862:219;;;;-1:-1:-1;;;3862:219:44;;5096:2:48;3862:219:44;;;5078:21:48;5135:2;5115:18;;;5108:30;-1:-1:-1;;;5154:18:48;;;5147:50;5214:18;;3862:219:44;4894:344:48;3862:219:44;4130:10;4154:34;;;;:22;:34;;;;;;;:43;;4211:42;;;;;4097:166;;;;;;2730:25:48;;2786:2;2771:18;;2764:34;2718:2;2703:18;;2556:248;4097:166:44;;;;;;;;4274:13;;;4325:10;4274:13;4349:34;;;:22;:34;;;;;;;;;:42;;;;4274:127;;-1:-1:-1;;;4274:127:44;;;;;1457:51:48;;;;1524:18;;;1517:34;-1:-1:-1;;;;;4274:13:44;;:37;;1430:18:48;;4274:127:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;4435:10:44;4456:1;4412:34;;;:22;:34;;;;;:41;;;:45;;;4467:47;;;4524:42;;:46;-1:-1:-1;;3020:1557:44:o;2315:410::-;1094:13:19;:11;:13::i;:::-;-1:-1:-1;;;;;2404:28:44;::::1;;::::0;;;:22:::1;:28;::::0;;;;:35:::1;;::::0;:40;;2383:121:::1;;;::::0;-1:-1:-1;;;2383:121:44;;5445:2:48;2383:121:44::1;::::0;::::1;5427:21:48::0;5484:2;5464:18;;;5457:30;5523:34;5503:18;;;5496:62;-1:-1:-1;;;5574:18:48;;;5567:32;5616:19;;2383:121:44::1;5243:398:48::0;2383:121:44::1;-1:-1:-1::0;;;;;2535:28:44;::::1;;::::0;;;:22:::1;:28;::::0;;;;:35:::1;::::0;;::::1;::::0;:40;;2514:114:::1;;;::::0;-1:-1:-1;;;2514:114:44;;5848:2:48;2514:114:44::1;::::0;::::1;5830:21:48::0;5887:2;5867:18;;;5860:30;5926:29;5906:18;;;5899:57;5973:18;;2514:114:44::1;5646:351:48::0;2514:114:44::1;-1:-1:-1::0;;;;;2639:28:44;::::1;;::::0;;;:22:::1;:28;::::0;;;;;2677:1:::1;2639:35:::0;;::::1;:39:::0;2694:24;::::1;::::0;2639:28;2694:24:::1;2315:410:::0;:::o;1824:101:19:-;1094:13;:11;:13::i;:::-;1888:30:::1;1915:1;1888:18;:30::i;:::-;1824:101::o:0;2731:283:44:-;1247:7:19;1273:6;-1:-1:-1;;;;;1273:6:19;2796:10:44;:21;;:43;;-1:-1:-1;2821:10:44;-1:-1:-1;;;;;2821:18:44;;;2796:43;2788:68;;;;-1:-1:-1;;;2788:68:44;;6204:2:48;2788:68:44;;;6186:21:48;6243:2;6223:18;;;6216:30;-1:-1:-1;;;6262:18:48;;;6255:42;6314:18;;2788:68:44;6002:336:48;2788:68:44;-1:-1:-1;;;;;2867:28:44;2905:1;2867:28;;;:22;:28;;;;;:35;;;:39;;;2916:41;;;2967:36;;:40;2731:283::o;2074:198:19:-;1094:13;:11;:13::i;:::-;-1:-1:-1;;;;;2162:22:19;::::1;2154:73;;;::::0;-1:-1:-1;;;2154:73:19;;6545:2:48;2154:73:19::1;::::0;::::1;6527:21:48::0;6584:2;6564:18;;;6557:30;6623:34;6603:18;;;6596:62;-1:-1:-1;;;6674:18:48;;;6667:36;6720:19;;2154:73:19::1;6343:402:48::0;2154:73:19::1;2237:28;2256:8;2237:18;:28::i;:::-;2074:198:::0;:::o;1359:130::-;1247:7;1273:6;-1:-1:-1;;;;;1273:6:19;719:10:32;1422:23:19;1414:68;;;;-1:-1:-1;;;1414:68:19;;6952:2:48;1414:68:19;;;6934:21:48;;;6971:18;;;6964:30;7030:34;7010:18;;;7003:62;7082:18;;1414:68:19;6750:356:48;2426:187:19;2499:16;2518:6;;-1:-1:-1;;;;;2534:17:19;;;-1:-1:-1;;;;;;2534:17:19;;;;;;2566:40;;2518:6;;;;;;;2566:40;;2499:16;2566:40;2489:124;2426:187;:::o;14:180:48:-;73:6;126:2;114:9;105:7;101:23;97:32;94:52;;;142:1;139;132:12;94:52;-1:-1:-1;165:23:48;;14:180;-1:-1:-1;14:180:48:o;199:286::-;258:6;311:2;299:9;290:7;286:23;282:32;279:52;;;327:1;324;317:12;279:52;353:23;;-1:-1:-1;;;;;405:31:48;;395:42;;385:70;;451:1;448;441:12;385:70;474:5;199:286;-1:-1:-1;;;199:286:48:o;1562:277::-;1629:6;1682:2;1670:9;1661:7;1657:23;1653:32;1650:52;;;1698:1;1695;1688:12;1650:52;1730:9;1724:16;1783:5;1776:13;1769:21;1762:5;1759:32;1749:60;;1805:1;1802;1795:12;3212:184;3282:6;3335:2;3323:9;3314:7;3310:23;3306:32;3303:52;;;3351:1;3348;3341:12;3303:52;-1:-1:-1;3374:16:48;;3212:184;-1:-1:-1;3212:184:48:o',
    linkReferences: {},
  },
  methodIdentifiers: {
    'approveRedemption(address)': '711a5c86',
    'finalizeRedemption()': '56cee8ab',
    'getStatus(address)': '30ccebb5',
    'owner()': '8da5cb5b',
    'paused()': '5c975abb',
    'redeemToken(uint256)': '013054c2',
    'rejectRedemption(address)': '92dd9f88',
    'renounceOwnership()': '715018a6',
    'transferOwnership(address)': 'f2fde38b',
  },
  rawMetadata:
    '{"compiler":{"version":"0.8.23+commit.f704f362"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"_rdaoAddress","type":"address"},{"internalType":"address","name":"_usdtAddress","type":"address"},{"internalType":"address","name":"_verificationAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"}],"name":"RedemptionApproved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":false,"internalType":"uint256","name":"daoTokenAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"usdtAmount","type":"uint256"}],"name":"RedemptionFinalized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"}],"name":"RedemptionRejected","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":false,"internalType":"uint256","name":"daoTokenAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"usdtAmount","type":"uint256"}],"name":"RedemptionSubmitted","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"approveRedemption","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"finalizeRedemption","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"getStatus","outputs":[{"components":[{"internalType":"uint256","name":"tokenAmt","type":"uint256"},{"internalType":"uint256","name":"usdtAmt","type":"uint256"},{"internalType":"uint256","name":"status","type":"uint256"}],"internalType":"struct Redemption.RedemptionSubmission","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"daoTokenAmount","type":"uint256"}],"name":"redeemToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"rejectRedemption","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"events":{"Paused(address)":{"details":"Emitted when the pause is triggered by `account`."},"Unpaused(address)":{"details":"Emitted when the pause is lifted by `account`."}},"kind":"dev","methods":{"owner()":{"details":"Returns the address of the current owner."},"paused()":{"details":"Returns true if the contract is paused, and false otherwise."},"renounceOwnership()":{"details":"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby disabling any functionality that is only available to the owner."},"transferOwnership(address)":{"details":"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."}},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}},"settings":{"compilationTarget":{"src/Redemption.sol":"Redemption"},"evmVersion":"paris","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[":ds-test/=lib/forge-std/lib/ds-test/src/",":erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",":forge-std/=lib/forge-std/src/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/"]},"sources":{"lib/openzeppelin-contracts/contracts/access/Ownable.sol":{"keccak256":"0xba43b97fba0d32eb4254f6a5a297b39a19a247082a02d6e69349e071e2946218","license":"MIT","urls":["bzz-raw://fc980984badf3984b6303b377711220e067722bbd6a135b24669ff5069ef9f32","dweb:/ipfs/QmPHXMSXj99XjSVM21YsY6aNtLLjLVXDbyN76J5HQYvvrz"]},"lib/openzeppelin-contracts/contracts/governance/utils/IVotes.sol":{"keccak256":"0x1618ddebe73377660f6da71afcba35d5ac4c4600918b3a381d9c6f37eba613eb","license":"MIT","urls":["bzz-raw://666c8d7c62478b55e082f1835275b7acfc1595491998df6d67183ff2c70eab96","dweb:/ipfs/QmVXmnXfxNaLhoX283dqyKJ8DJbF5thUd9sMuRoFpNMwr7"]},"lib/openzeppelin-contracts/contracts/interfaces/IERC5267.sol":{"keccak256":"0xac6c2efc64baccbde4904ae18ed45139c9aa8cff96d6888344d1e4d2eb8b659f","license":"MIT","urls":["bzz-raw://6e416a280c610b6b7a5f158e4a41aacfaec01ef14d5d1de13b46be9e090265fc","dweb:/ipfs/QmYZP2KrdyccBbhLZT42auhvBTMkwiwUS3V6HWb42rbwbG"]},"lib/openzeppelin-contracts/contracts/interfaces/IERC5805.sol":{"keccak256":"0xfc12b717f6a2cd0d67adc8700097d4464d37f18ce933d4fc9c948ab6aec35e80","license":"MIT","urls":["bzz-raw://82386e69ebe902a2edfd4f8a5ecbeaeb2e00f6cc6481a973729e974373fb492e","dweb:/ipfs/QmSXg4wBMBd83mQvkekT1GsiRX2Qyv5gvrqzv5qJx2M7Kc"]},"lib/openzeppelin-contracts/contracts/interfaces/IERC6372.sol":{"keccak256":"0xcaea9aeda3816ba872358c828f4f01455c22ae48ced49c4c7d72bd74176c09b9","license":"MIT","urls":["bzz-raw://16ff22d8df5aee94510ee43d361b6147caef164941a684cedcb75be44f351fe6","dweb:/ipfs/QmaCCwMdHVdPApuEJHLZapSJyA7mp5dAugpma3VUzWGd8E"]},"lib/openzeppelin-contracts/contracts/security/Pausable.sol":{"keccak256":"0x0849d93b16c9940beb286a7864ed02724b248b93e0d80ef6355af5ef15c64773","license":"MIT","urls":["bzz-raw://4ddabb16009cd17eaca3143feadf450ac13e72919ebe2ca50e00f61cb78bc004","dweb:/ipfs/QmSPwPxX7d6TTWakN5jy5wsaGkS1y9TW8fuhGSraMkLk2B"]},"lib/openzeppelin-contracts/contracts/token/ERC20/ERC20.sol":{"keccak256":"0xa56ca923f70c1748830700250b19c61b70db9a683516dc5e216694a50445d99c","license":"MIT","urls":["bzz-raw://cac938788bc4be12101e59d45588b4e059579f4e61062e1cda8d6b06c0191b15","dweb:/ipfs/QmV2JKCyjTVH3rkWNrfdJRhAT7tZ3usAN2XcnD4h53Mvih"]},"lib/openzeppelin-contracts/contracts/token/ERC20/IERC20.sol":{"keccak256":"0x287b55befed2961a7eabd7d7b1b2839cbca8a5b80ef8dcbb25ed3d4c2002c305","license":"MIT","urls":["bzz-raw://bd39944e8fc06be6dbe2dd1d8449b5336e23c6a7ba3e8e9ae5ae0f37f35283f5","dweb:/ipfs/QmPV3FGYjVwvKSgAXKUN3r9T9GwniZz83CxBpM7vyj2G53"]},"lib/openzeppelin-contracts/contracts/token/ERC20/extensions/ERC20Permit.sol":{"keccak256":"0x36c00327e3f9afd929cc2721aaa111ab57eff78a630cc364b279ad576b899295","license":"MIT","urls":["bzz-raw://f5bf927f4c8b71a5809be184c3107b915b0445ab2c4a33208331e5376692eb5a","dweb:/ipfs/QmVXirsCY1sf4kodhbL6w3NWZkeZeaMuQB7M6DBAdZNqFE"]},"lib/openzeppelin-contracts/contracts/token/ERC20/extensions/ERC20Votes.sol":{"keccak256":"0x4e560f86662b6f72ab76122fff53317677154f14bac4a80dbd46a54172b3abfa","license":"MIT","urls":["bzz-raw://ca5c2518d247417cb01164f04eff57b7e87b5346bc03478ada916f26117aa7fd","dweb:/ipfs/QmVgK66XGZCiH9x4mhqejKUTujtu68DyE6KrYi6MPuaHRJ"]},"lib/openzeppelin-contracts/contracts/token/ERC20/extensions/IERC20Metadata.sol":{"keccak256":"0x8de418a5503946cabe331f35fe242d3201a73f67f77aaeb7110acb1f30423aca","license":"MIT","urls":["bzz-raw://5a376d3dda2cb70536c0a45c208b29b34ac560c4cb4f513a42079f96ba47d2dd","dweb:/ipfs/QmZQg6gn1sUpM8wHzwNvSnihumUCAhxD119MpXeKp8B9s8"]},"lib/openzeppelin-contracts/contracts/token/ERC20/extensions/IERC20Permit.sol":{"keccak256":"0xec63854014a5b4f2b3290ab9103a21bdf902a508d0f41a8573fea49e98bf571a","license":"MIT","urls":["bzz-raw://bc5b5dc12fbc4002f282eaa7a5f06d8310ed62c1c77c5770f6283e058454c39a","dweb:/ipfs/Qme9rE2wS3yBuyJq9GgbmzbsBQsW2M2sVFqYYLw7bosGrv"]},"lib/openzeppelin-contracts/contracts/token/ERC20/extensions/draft-ERC20Permit.sol":{"keccak256":"0xbe43b6f1e04b5215939f1a76fa612c275b75948f6e7bf25808fb91e99444a33f","license":"MIT","urls":["bzz-raw://86d672d9a23f3502472f6827af8e8116a6412b28c234dcfcb201413055cb0159","dweb:/ipfs/Qmcts6GvEMHuyikwDHtcTdTW4SVP1k66KpUMRcCovWbLN8"]},"lib/openzeppelin-contracts/contracts/utils/Context.sol":{"keccak256":"0xe2e337e6dde9ef6b680e07338c493ebea1b5fd09b43424112868e9cc1706bca7","license":"MIT","urls":["bzz-raw://6df0ddf21ce9f58271bdfaa85cde98b200ef242a05a3f85c2bc10a8294800a92","dweb:/ipfs/QmRK2Y5Yc6BK7tGKkgsgn3aJEQGi5aakeSPZvS65PV8Xp3"]},"lib/openzeppelin-contracts/contracts/utils/Counters.sol":{"keccak256":"0xf0018c2440fbe238dd3a8732fa8e17a0f9dce84d31451dc8a32f6d62b349c9f1","license":"MIT","urls":["bzz-raw://59e1c62884d55b70f3ae5432b44bb3166ad71ae3acd19c57ab6ddc3c87c325ee","dweb:/ipfs/QmezuXg5GK5oeA4F91EZhozBFekhq5TD966bHPH18cCqhu"]},"lib/openzeppelin-contracts/contracts/utils/ShortStrings.sol":{"keccak256":"0xc0e310c163edf15db45d4ff938113ab357f94fa86e61ea8e790853c4d2e13256","license":"MIT","urls":["bzz-raw://04db5bc05dcb05ba1f6ca2dfbead17adc8a2e2f911aa80b05e7a36d9eaf96516","dweb:/ipfs/QmVkfHZbXVBUPsTopueCn3qGJX8aEjahFF3Fn4NcygLNm5"]},"lib/openzeppelin-contracts/contracts/utils/StorageSlot.sol":{"keccak256":"0xf09e68aa0dc6722a25bc46490e8d48ed864466d17313b8a0b254c36b54e49899","license":"MIT","urls":["bzz-raw://e26daf81e2252dc1fe1ce0e4b55c2eb7c6d1ee84ae6558d1a9554432ea1d32da","dweb:/ipfs/Qmb1UANWiWq5pCKbmHSu772hd4nt374dVaghGmwSVNuk8Q"]},"lib/openzeppelin-contracts/contracts/utils/Strings.sol":{"keccak256":"0x3088eb2868e8d13d89d16670b5f8612c4ab9ff8956272837d8e90106c59c14a0","license":"MIT","urls":["bzz-raw://b81d9ff6559ea5c47fc573e17ece6d9ba5d6839e213e6ebc3b4c5c8fe4199d7f","dweb:/ipfs/QmPCW1bFisUzJkyjroY3yipwfism9RRCigCcK1hbXtVM8n"]},"lib/openzeppelin-contracts/contracts/utils/cryptography/ECDSA.sol":{"keccak256":"0x809bc3edb4bcbef8263fa616c1b60ee0004b50a8a1bfa164d8f57fd31f520c58","license":"MIT","urls":["bzz-raw://8b93a1e39a4a19eba1600b92c96f435442db88cac91e315c8291547a2a7bcfe2","dweb:/ipfs/QmTm34KVe6uZBZwq8dZDNWwPcm24qBJdxqL3rPxBJ4LrMv"]},"lib/openzeppelin-contracts/contracts/utils/cryptography/EIP712.sol":{"keccak256":"0x8432884527a7ad91e6eed1cfc5a0811ae2073e5bca107bd0ca442e9236b03dbd","license":"MIT","urls":["bzz-raw://e3aa0eadab7aafcf91a95684765f778f64386f0368de88522ce873c21385278a","dweb:/ipfs/QmPfaVAqWgH1QsT3dHVuL6jwMZbVKdoP8w1PvpiPT2FPWd"]},"lib/openzeppelin-contracts/contracts/utils/math/Math.sol":{"keccak256":"0xe4455ac1eb7fc497bb7402579e7b4d64d928b846fce7d2b6fde06d366f21c2b3","license":"MIT","urls":["bzz-raw://cc8841b3cd48ad125e2f46323c8bad3aa0e88e399ec62acb9e57efa7e7c8058c","dweb:/ipfs/QmSqE4mXHA2BXW58deDbXE8MTcsL5JSKNDbm23sVQxRLPS"]},"lib/openzeppelin-contracts/contracts/utils/math/SafeCast.sol":{"keccak256":"0x52a8cfb0f5239d11b457dcdd1b326992ef672714ca8da71a157255bddd13f3ad","license":"MIT","urls":["bzz-raw://495145362c7ff1c9ca88c58bbbbcb412e3c2004406647412394486552ff6c278","dweb:/ipfs/QmNNCeng6d5eRPDn6tkWSQhjE39XWfQEfjA63rRwHmr1iH"]},"lib/openzeppelin-contracts/contracts/utils/math/SignedMath.sol":{"keccak256":"0xf92515413956f529d95977adc9b0567d583c6203fc31ab1c23824c35187e3ddc","license":"MIT","urls":["bzz-raw://c50fcc459e49a9858b6d8ad5f911295cb7c9ab57567845a250bf0153f84a95c7","dweb:/ipfs/QmcEW85JRzvDkQggxiBBLVAasXWdkhEysqypj9EaB6H2g6"]},"src/Redemption.sol":{"keccak256":"0x0a3a4e183a748e28f0c6e2ba5faf1075aefa0aad87f576e20e37d592b3d408a4","license":"MIT","urls":["bzz-raw://9cf99fa86521a9ec72af710b18f4a2c611df0b01b07c5cb3a6a082b99d9e7dc4","dweb:/ipfs/QmekFJcB3fEnjpTR9EHZYR8VVRRzgNZreJmk2qCUwCMDuH"]},"src/Verification.sol":{"keccak256":"0xcf5afa20b6e85e1e560f223e8eb9f6a0c7b3eb3d5b78402276b17a2ebf7b82d8","license":"MIT","urls":["bzz-raw://90d446d94b64a9df0401945005216557821fe953b754ade82fc43f1b306114e5","dweb:/ipfs/QmV9Z45QyeU4PNKjXSzEeQj7HP47uyjaj4ErFLXqKmhyyM"]},"src/token/RegionalDaoToken.sol":{"keccak256":"0x0c3e995cda9c193a5af34cf29dd1a2122ffbc128406eb0a0c8609e4f97d5ecbe","license":"MIT","urls":["bzz-raw://d62c92e263fd7c37ba238ef1cc9fd04b6b103943e14578aed0e1d1a0d26bac6f","dweb:/ipfs/QmfZhCsHxu6roETtnk85EBZthwyufTcozKbjKRv3cFixbP"]}},"version":1}',
  metadata: {
    compiler: {
      version: '0.8.23+commit.f704f362',
    },
    language: 'Solidity',
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: 'address',
              name: '_rdaoAddress',
              type: 'address',
            },
            {
              internalType: 'address',
              name: '_usdtAddress',
              type: 'address',
            },
            {
              internalType: 'address',
              name: '_verificationAddress',
              type: 'address',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'constructor',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'previousOwner',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'address',
              name: 'newOwner',
              type: 'address',
              indexed: true,
            },
          ],
          type: 'event',
          name: 'OwnershipTransferred',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'account',
              type: 'address',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'Paused',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
          ],
          type: 'event',
          name: 'RedemptionApproved',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'uint256',
              name: 'daoTokenAmount',
              type: 'uint256',
              indexed: false,
            },
            {
              internalType: 'uint256',
              name: 'usdtAmount',
              type: 'uint256',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'RedemptionFinalized',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
          ],
          type: 'event',
          name: 'RedemptionRejected',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'uint256',
              name: 'daoTokenAmount',
              type: 'uint256',
              indexed: false,
            },
            {
              internalType: 'uint256',
              name: 'usdtAmount',
              type: 'uint256',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'RedemptionSubmitted',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'account',
              type: 'address',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'Unpaused',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'user',
              type: 'address',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'approveRedemption',
        },
        {
          inputs: [],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'finalizeRedemption',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'user',
              type: 'address',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'getStatus',
          outputs: [
            {
              internalType: 'struct Redemption.RedemptionSubmission',
              name: '',
              type: 'tuple',
              components: [
                {
                  internalType: 'uint256',
                  name: 'tokenAmt',
                  type: 'uint256',
                },
                {
                  internalType: 'uint256',
                  name: 'usdtAmt',
                  type: 'uint256',
                },
                {
                  internalType: 'uint256',
                  name: 'status',
                  type: 'uint256',
                },
              ],
            },
          ],
        },
        {
          inputs: [],
          stateMutability: 'view',
          type: 'function',
          name: 'owner',
          outputs: [
            {
              internalType: 'address',
              name: '',
              type: 'address',
            },
          ],
        },
        {
          inputs: [],
          stateMutability: 'view',
          type: 'function',
          name: 'paused',
          outputs: [
            {
              internalType: 'bool',
              name: '',
              type: 'bool',
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'uint256',
              name: 'daoTokenAmount',
              type: 'uint256',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'redeemToken',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'user',
              type: 'address',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'rejectRedemption',
        },
        {
          inputs: [],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'renounceOwnership',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'newOwner',
              type: 'address',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'transferOwnership',
        },
      ],
      devdoc: {
        kind: 'dev',
        methods: {
          'owner()': {
            details: 'Returns the address of the current owner.',
          },
          'paused()': {
            details:
              'Returns true if the contract is paused, and false otherwise.',
          },
          'renounceOwnership()': {
            details:
              'Leaves the contract without owner. It will not be possible to call `onlyOwner` functions. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby disabling any functionality that is only available to the owner.',
          },
          'transferOwnership(address)': {
            details:
              'Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.',
          },
        },
        version: 1,
      },
      userdoc: {
        kind: 'user',
        methods: {},
        version: 1,
      },
    },
    settings: {
      remappings: [
        'ds-test/=lib/forge-std/lib/ds-test/src/',
        'erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/',
        'forge-std/=lib/forge-std/src/',
        'openzeppelin-contracts/=lib/openzeppelin-contracts/',
        'openzeppelin/=lib/openzeppelin-contracts/contracts/',
      ],
      optimizer: {
        enabled: true,
        runs: 200,
      },
      metadata: {
        bytecodeHash: 'ipfs',
      },
      compilationTarget: {
        'src/Redemption.sol': 'Redemption',
      },
      libraries: {},
    },
    sources: {
      'lib/openzeppelin-contracts/contracts/access/Ownable.sol': {
        keccak256:
          '0xba43b97fba0d32eb4254f6a5a297b39a19a247082a02d6e69349e071e2946218',
        urls: [
          'bzz-raw://fc980984badf3984b6303b377711220e067722bbd6a135b24669ff5069ef9f32',
          'dweb:/ipfs/QmPHXMSXj99XjSVM21YsY6aNtLLjLVXDbyN76J5HQYvvrz',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/governance/utils/IVotes.sol': {
        keccak256:
          '0x1618ddebe73377660f6da71afcba35d5ac4c4600918b3a381d9c6f37eba613eb',
        urls: [
          'bzz-raw://666c8d7c62478b55e082f1835275b7acfc1595491998df6d67183ff2c70eab96',
          'dweb:/ipfs/QmVXmnXfxNaLhoX283dqyKJ8DJbF5thUd9sMuRoFpNMwr7',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/interfaces/IERC5267.sol': {
        keccak256:
          '0xac6c2efc64baccbde4904ae18ed45139c9aa8cff96d6888344d1e4d2eb8b659f',
        urls: [
          'bzz-raw://6e416a280c610b6b7a5f158e4a41aacfaec01ef14d5d1de13b46be9e090265fc',
          'dweb:/ipfs/QmYZP2KrdyccBbhLZT42auhvBTMkwiwUS3V6HWb42rbwbG',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/interfaces/IERC5805.sol': {
        keccak256:
          '0xfc12b717f6a2cd0d67adc8700097d4464d37f18ce933d4fc9c948ab6aec35e80',
        urls: [
          'bzz-raw://82386e69ebe902a2edfd4f8a5ecbeaeb2e00f6cc6481a973729e974373fb492e',
          'dweb:/ipfs/QmSXg4wBMBd83mQvkekT1GsiRX2Qyv5gvrqzv5qJx2M7Kc',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/interfaces/IERC6372.sol': {
        keccak256:
          '0xcaea9aeda3816ba872358c828f4f01455c22ae48ced49c4c7d72bd74176c09b9',
        urls: [
          'bzz-raw://16ff22d8df5aee94510ee43d361b6147caef164941a684cedcb75be44f351fe6',
          'dweb:/ipfs/QmaCCwMdHVdPApuEJHLZapSJyA7mp5dAugpma3VUzWGd8E',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/security/Pausable.sol': {
        keccak256:
          '0x0849d93b16c9940beb286a7864ed02724b248b93e0d80ef6355af5ef15c64773',
        urls: [
          'bzz-raw://4ddabb16009cd17eaca3143feadf450ac13e72919ebe2ca50e00f61cb78bc004',
          'dweb:/ipfs/QmSPwPxX7d6TTWakN5jy5wsaGkS1y9TW8fuhGSraMkLk2B',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/token/ERC20/ERC20.sol': {
        keccak256:
          '0xa56ca923f70c1748830700250b19c61b70db9a683516dc5e216694a50445d99c',
        urls: [
          'bzz-raw://cac938788bc4be12101e59d45588b4e059579f4e61062e1cda8d6b06c0191b15',
          'dweb:/ipfs/QmV2JKCyjTVH3rkWNrfdJRhAT7tZ3usAN2XcnD4h53Mvih',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/token/ERC20/IERC20.sol': {
        keccak256:
          '0x287b55befed2961a7eabd7d7b1b2839cbca8a5b80ef8dcbb25ed3d4c2002c305',
        urls: [
          'bzz-raw://bd39944e8fc06be6dbe2dd1d8449b5336e23c6a7ba3e8e9ae5ae0f37f35283f5',
          'dweb:/ipfs/QmPV3FGYjVwvKSgAXKUN3r9T9GwniZz83CxBpM7vyj2G53',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/token/ERC20/extensions/ERC20Permit.sol':
        {
          keccak256:
            '0x36c00327e3f9afd929cc2721aaa111ab57eff78a630cc364b279ad576b899295',
          urls: [
            'bzz-raw://f5bf927f4c8b71a5809be184c3107b915b0445ab2c4a33208331e5376692eb5a',
            'dweb:/ipfs/QmVXirsCY1sf4kodhbL6w3NWZkeZeaMuQB7M6DBAdZNqFE',
          ],
          license: 'MIT',
        },
      'lib/openzeppelin-contracts/contracts/token/ERC20/extensions/ERC20Votes.sol':
        {
          keccak256:
            '0x4e560f86662b6f72ab76122fff53317677154f14bac4a80dbd46a54172b3abfa',
          urls: [
            'bzz-raw://ca5c2518d247417cb01164f04eff57b7e87b5346bc03478ada916f26117aa7fd',
            'dweb:/ipfs/QmVgK66XGZCiH9x4mhqejKUTujtu68DyE6KrYi6MPuaHRJ',
          ],
          license: 'MIT',
        },
      'lib/openzeppelin-contracts/contracts/token/ERC20/extensions/IERC20Metadata.sol':
        {
          keccak256:
            '0x8de418a5503946cabe331f35fe242d3201a73f67f77aaeb7110acb1f30423aca',
          urls: [
            'bzz-raw://5a376d3dda2cb70536c0a45c208b29b34ac560c4cb4f513a42079f96ba47d2dd',
            'dweb:/ipfs/QmZQg6gn1sUpM8wHzwNvSnihumUCAhxD119MpXeKp8B9s8',
          ],
          license: 'MIT',
        },
      'lib/openzeppelin-contracts/contracts/token/ERC20/extensions/IERC20Permit.sol':
        {
          keccak256:
            '0xec63854014a5b4f2b3290ab9103a21bdf902a508d0f41a8573fea49e98bf571a',
          urls: [
            'bzz-raw://bc5b5dc12fbc4002f282eaa7a5f06d8310ed62c1c77c5770f6283e058454c39a',
            'dweb:/ipfs/Qme9rE2wS3yBuyJq9GgbmzbsBQsW2M2sVFqYYLw7bosGrv',
          ],
          license: 'MIT',
        },
      'lib/openzeppelin-contracts/contracts/token/ERC20/extensions/draft-ERC20Permit.sol':
        {
          keccak256:
            '0xbe43b6f1e04b5215939f1a76fa612c275b75948f6e7bf25808fb91e99444a33f',
          urls: [
            'bzz-raw://86d672d9a23f3502472f6827af8e8116a6412b28c234dcfcb201413055cb0159',
            'dweb:/ipfs/Qmcts6GvEMHuyikwDHtcTdTW4SVP1k66KpUMRcCovWbLN8',
          ],
          license: 'MIT',
        },
      'lib/openzeppelin-contracts/contracts/utils/Context.sol': {
        keccak256:
          '0xe2e337e6dde9ef6b680e07338c493ebea1b5fd09b43424112868e9cc1706bca7',
        urls: [
          'bzz-raw://6df0ddf21ce9f58271bdfaa85cde98b200ef242a05a3f85c2bc10a8294800a92',
          'dweb:/ipfs/QmRK2Y5Yc6BK7tGKkgsgn3aJEQGi5aakeSPZvS65PV8Xp3',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/Counters.sol': {
        keccak256:
          '0xf0018c2440fbe238dd3a8732fa8e17a0f9dce84d31451dc8a32f6d62b349c9f1',
        urls: [
          'bzz-raw://59e1c62884d55b70f3ae5432b44bb3166ad71ae3acd19c57ab6ddc3c87c325ee',
          'dweb:/ipfs/QmezuXg5GK5oeA4F91EZhozBFekhq5TD966bHPH18cCqhu',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/ShortStrings.sol': {
        keccak256:
          '0xc0e310c163edf15db45d4ff938113ab357f94fa86e61ea8e790853c4d2e13256',
        urls: [
          'bzz-raw://04db5bc05dcb05ba1f6ca2dfbead17adc8a2e2f911aa80b05e7a36d9eaf96516',
          'dweb:/ipfs/QmVkfHZbXVBUPsTopueCn3qGJX8aEjahFF3Fn4NcygLNm5',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/StorageSlot.sol': {
        keccak256:
          '0xf09e68aa0dc6722a25bc46490e8d48ed864466d17313b8a0b254c36b54e49899',
        urls: [
          'bzz-raw://e26daf81e2252dc1fe1ce0e4b55c2eb7c6d1ee84ae6558d1a9554432ea1d32da',
          'dweb:/ipfs/Qmb1UANWiWq5pCKbmHSu772hd4nt374dVaghGmwSVNuk8Q',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/Strings.sol': {
        keccak256:
          '0x3088eb2868e8d13d89d16670b5f8612c4ab9ff8956272837d8e90106c59c14a0',
        urls: [
          'bzz-raw://b81d9ff6559ea5c47fc573e17ece6d9ba5d6839e213e6ebc3b4c5c8fe4199d7f',
          'dweb:/ipfs/QmPCW1bFisUzJkyjroY3yipwfism9RRCigCcK1hbXtVM8n',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/cryptography/ECDSA.sol': {
        keccak256:
          '0x809bc3edb4bcbef8263fa616c1b60ee0004b50a8a1bfa164d8f57fd31f520c58',
        urls: [
          'bzz-raw://8b93a1e39a4a19eba1600b92c96f435442db88cac91e315c8291547a2a7bcfe2',
          'dweb:/ipfs/QmTm34KVe6uZBZwq8dZDNWwPcm24qBJdxqL3rPxBJ4LrMv',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/cryptography/EIP712.sol': {
        keccak256:
          '0x8432884527a7ad91e6eed1cfc5a0811ae2073e5bca107bd0ca442e9236b03dbd',
        urls: [
          'bzz-raw://e3aa0eadab7aafcf91a95684765f778f64386f0368de88522ce873c21385278a',
          'dweb:/ipfs/QmPfaVAqWgH1QsT3dHVuL6jwMZbVKdoP8w1PvpiPT2FPWd',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/math/Math.sol': {
        keccak256:
          '0xe4455ac1eb7fc497bb7402579e7b4d64d928b846fce7d2b6fde06d366f21c2b3',
        urls: [
          'bzz-raw://cc8841b3cd48ad125e2f46323c8bad3aa0e88e399ec62acb9e57efa7e7c8058c',
          'dweb:/ipfs/QmSqE4mXHA2BXW58deDbXE8MTcsL5JSKNDbm23sVQxRLPS',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/math/SafeCast.sol': {
        keccak256:
          '0x52a8cfb0f5239d11b457dcdd1b326992ef672714ca8da71a157255bddd13f3ad',
        urls: [
          'bzz-raw://495145362c7ff1c9ca88c58bbbbcb412e3c2004406647412394486552ff6c278',
          'dweb:/ipfs/QmNNCeng6d5eRPDn6tkWSQhjE39XWfQEfjA63rRwHmr1iH',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/math/SignedMath.sol': {
        keccak256:
          '0xf92515413956f529d95977adc9b0567d583c6203fc31ab1c23824c35187e3ddc',
        urls: [
          'bzz-raw://c50fcc459e49a9858b6d8ad5f911295cb7c9ab57567845a250bf0153f84a95c7',
          'dweb:/ipfs/QmcEW85JRzvDkQggxiBBLVAasXWdkhEysqypj9EaB6H2g6',
        ],
        license: 'MIT',
      },
      'src/Redemption.sol': {
        keccak256:
          '0x0a3a4e183a748e28f0c6e2ba5faf1075aefa0aad87f576e20e37d592b3d408a4',
        urls: [
          'bzz-raw://9cf99fa86521a9ec72af710b18f4a2c611df0b01b07c5cb3a6a082b99d9e7dc4',
          'dweb:/ipfs/QmekFJcB3fEnjpTR9EHZYR8VVRRzgNZreJmk2qCUwCMDuH',
        ],
        license: 'MIT',
      },
      'src/Verification.sol': {
        keccak256:
          '0xcf5afa20b6e85e1e560f223e8eb9f6a0c7b3eb3d5b78402276b17a2ebf7b82d8',
        urls: [
          'bzz-raw://90d446d94b64a9df0401945005216557821fe953b754ade82fc43f1b306114e5',
          'dweb:/ipfs/QmV9Z45QyeU4PNKjXSzEeQj7HP47uyjaj4ErFLXqKmhyyM',
        ],
        license: 'MIT',
      },
      'src/token/RegionalDaoToken.sol': {
        keccak256:
          '0x0c3e995cda9c193a5af34cf29dd1a2122ffbc128406eb0a0c8609e4f97d5ecbe',
        urls: [
          'bzz-raw://d62c92e263fd7c37ba238ef1cc9fd04b6b103943e14578aed0e1d1a0d26bac6f',
          'dweb:/ipfs/QmfZhCsHxu6roETtnk85EBZthwyufTcozKbjKRv3cFixbP',
        ],
        license: 'MIT',
      },
    },
    version: 1,
  },
  ast: {
    absolutePath: 'src/Redemption.sol',
    id: 49562,
    exportedSymbols: {
      Context: [45392],
      Counters: [45466],
      ECDSA: [46387],
      EIP712: [46591],
      ERC20: [44322],
      ERC20Permit: [44572],
      ERC20Votes: [45306],
      IERC20: [44400],
      IERC20Metadata: [45331],
      IERC20Permit: [45367],
      IERC5267: [43603],
      IERC5805: [43612],
      IERC6372: [43627],
      IVotes: [43578],
      Math: [47457],
      Ownable: [43500],
      Pausable: [43735],
      Redemption: [49561],
      RegionalDaoToken: [50188],
      SafeCast: [48998],
      ShortString: [45471],
      ShortStrings: [45682],
      SignedMath: [49103],
      StorageSlot: [45792],
      Strings: [46021],
      Verification: [50009],
    },
    nodeType: 'SourceUnit',
    src: '32:4548:44',
    nodes: [
      {
        id: 49207,
        nodeType: 'PragmaDirective',
        src: '32:23:44',
        nodes: [],
        literals: ['solidity', '^', '0.8', '.0'],
      },
      {
        id: 49208,
        nodeType: 'ImportDirective',
        src: '299:38:44',
        nodes: [],
        absolutePath: 'src/token/RegionalDaoToken.sol',
        file: './token/RegionalDaoToken.sol',
        nameLocation: '-1:-1:-1',
        scope: 49562,
        sourceUnit: 50189,
        symbolAliases: [],
        unitAlias: '',
      },
      {
        id: 49209,
        nodeType: 'ImportDirective',
        src: '338:28:44',
        nodes: [],
        absolutePath: 'src/Verification.sol',
        file: './Verification.sol',
        nameLocation: '-1:-1:-1',
        scope: 49562,
        sourceUnit: 50010,
        symbolAliases: [],
        unitAlias: '',
      },
      {
        id: 49210,
        nodeType: 'ImportDirective',
        src: '368:68:44',
        nodes: [],
        absolutePath: 'lib/openzeppelin-contracts/contracts/access/Ownable.sol',
        file: '../lib/openzeppelin-contracts/contracts/access/Ownable.sol',
        nameLocation: '-1:-1:-1',
        scope: 49562,
        sourceUnit: 43501,
        symbolAliases: [],
        unitAlias: '',
      },
      {
        id: 49211,
        nodeType: 'ImportDirective',
        src: '437:71:44',
        nodes: [],
        absolutePath:
          'lib/openzeppelin-contracts/contracts/security/Pausable.sol',
        file: '../lib/openzeppelin-contracts/contracts/security/Pausable.sol',
        nameLocation: '-1:-1:-1',
        scope: 49562,
        sourceUnit: 43736,
        symbolAliases: [],
        unitAlias: '',
      },
      {
        id: 49561,
        nodeType: 'ContractDefinition',
        src: '510:4069:44',
        nodes: [
          {
            id: 49218,
            nodeType: 'VariableDeclaration',
            src: '557:34:44',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_verification',
            nameLocation: '578:13:44',
            scope: 49561,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_contract$_Verification_$50009',
              typeString: 'contract Verification',
            },
            typeName: {
              id: 49217,
              nodeType: 'UserDefinedTypeName',
              pathNode: {
                id: 49216,
                name: 'Verification',
                nameLocations: ['557:12:44'],
                nodeType: 'IdentifierPath',
                referencedDeclaration: 50009,
                src: '557:12:44',
              },
              referencedDeclaration: 50009,
              src: '557:12:44',
              typeDescriptions: {
                typeIdentifier: 't_contract$_Verification_$50009',
                typeString: 'contract Verification',
              },
            },
            visibility: 'private',
          },
          {
            id: 49221,
            nodeType: 'VariableDeclaration',
            src: '597:30:44',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_rdao',
            nameLocation: '622:5:44',
            scope: 49561,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
              typeString: 'contract RegionalDaoToken',
            },
            typeName: {
              id: 49220,
              nodeType: 'UserDefinedTypeName',
              pathNode: {
                id: 49219,
                name: 'RegionalDaoToken',
                nameLocations: ['597:16:44'],
                nodeType: 'IdentifierPath',
                referencedDeclaration: 50188,
                src: '597:16:44',
              },
              referencedDeclaration: 50188,
              src: '597:16:44',
              typeDescriptions: {
                typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                typeString: 'contract RegionalDaoToken',
              },
            },
            visibility: 'private',
          },
          {
            id: 49224,
            nodeType: 'VariableDeclaration',
            src: '633:30:44',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_usdt',
            nameLocation: '658:5:44',
            scope: 49561,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
              typeString: 'contract RegionalDaoToken',
            },
            typeName: {
              id: 49223,
              nodeType: 'UserDefinedTypeName',
              pathNode: {
                id: 49222,
                name: 'RegionalDaoToken',
                nameLocations: ['633:16:44'],
                nodeType: 'IdentifierPath',
                referencedDeclaration: 50188,
                src: '633:16:44',
              },
              referencedDeclaration: 50188,
              src: '633:16:44',
              typeDescriptions: {
                typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                typeString: 'contract RegionalDaoToken',
              },
            },
            visibility: 'private',
          },
          {
            id: 49232,
            nodeType: 'EventDefinition',
            src: '669:124:44',
            nodes: [],
            anonymous: false,
            eventSelector:
              'b3a4f2e02befe5c50f8f6de1fa373cc36fe0a3b215d7104cb0feeb5c3b20c150',
            name: 'RedemptionSubmitted',
            nameLocation: '675:19:44',
            parameters: {
              id: 49231,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49226,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '720:6:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49232,
                  src: '704:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49225,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '704:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49228,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'daoTokenAmount',
                  nameLocation: '744:14:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49232,
                  src: '736:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49227,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '736:7:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49230,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'usdtAmount',
                  nameLocation: '776:10:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49232,
                  src: '768:18:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49229,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '768:7:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '694:98:44',
            },
          },
          {
            id: 49236,
            nodeType: 'EventDefinition',
            src: '798:49:44',
            nodes: [],
            anonymous: false,
            eventSelector:
              'c2f3d6c38501c14087e8da7ae42f7038ba996a2e0a9a0e97ea99cad99f03621e',
            name: 'RedemptionApproved',
            nameLocation: '804:18:44',
            parameters: {
              id: 49235,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49234,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '839:6:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49236,
                  src: '823:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49233,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '823:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '822:24:44',
            },
          },
          {
            id: 49240,
            nodeType: 'EventDefinition',
            src: '852:49:44',
            nodes: [],
            anonymous: false,
            eventSelector:
              '6142db72a3e853089babce8ee1529ef012b1bf6e9347e51ece2c86198dc0b3a0',
            name: 'RedemptionRejected',
            nameLocation: '858:18:44',
            parameters: {
              id: 49239,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49238,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '893:6:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49240,
                  src: '877:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49237,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '877:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '876:24:44',
            },
          },
          {
            id: 49248,
            nodeType: 'EventDefinition',
            src: '906:124:44',
            nodes: [],
            anonymous: false,
            eventSelector:
              'fec12f632c814860c9f166795deb25cba0668e2cbfa82b36e8f8721791f62849',
            name: 'RedemptionFinalized',
            nameLocation: '912:19:44',
            parameters: {
              id: 49247,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49242,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '957:6:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49248,
                  src: '941:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49241,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '941:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49244,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'daoTokenAmount',
                  nameLocation: '981:14:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49248,
                  src: '973:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49243,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '973:7:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49246,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'usdtAmount',
                  nameLocation: '1013:10:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49248,
                  src: '1005:18:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49245,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '1005:7:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '931:98:44',
            },
          },
          {
            id: 49255,
            nodeType: 'StructDefinition',
            src: '1035:110:44',
            nodes: [],
            canonicalName: 'Redemption.RedemptionSubmission',
            members: [
              {
                constant: false,
                id: 49250,
                mutability: 'mutable',
                name: 'tokenAmt',
                nameLocation: '1081:8:44',
                nodeType: 'VariableDeclaration',
                scope: 49255,
                src: '1073:16:44',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 49249,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '1073:7:44',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 49252,
                mutability: 'mutable',
                name: 'usdtAmt',
                nameLocation: '1107:7:44',
                nodeType: 'VariableDeclaration',
                scope: 49255,
                src: '1099:15:44',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 49251,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '1099:7:44',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 49254,
                mutability: 'mutable',
                name: 'status',
                nameLocation: '1132:6:44',
                nodeType: 'VariableDeclaration',
                scope: 49255,
                src: '1124:14:44',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 49253,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '1124:7:44',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
            ],
            name: 'RedemptionSubmission',
            nameLocation: '1042:20:44',
            scope: 49561,
            visibility: 'public',
          },
          {
            id: 49260,
            nodeType: 'VariableDeclaration',
            src: '1150:71:44',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_redemptionSubmissions',
            nameLocation: '1199:22:44',
            scope: 49561,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier:
                't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
              typeString:
                'mapping(address => struct Redemption.RedemptionSubmission)',
            },
            typeName: {
              id: 49259,
              keyName: '',
              keyNameLocation: '-1:-1:-1',
              keyType: {
                id: 49256,
                name: 'address',
                nodeType: 'ElementaryTypeName',
                src: '1158:7:44',
                typeDescriptions: {
                  typeIdentifier: 't_address',
                  typeString: 'address',
                },
              },
              nodeType: 'Mapping',
              src: '1150:40:44',
              typeDescriptions: {
                typeIdentifier:
                  't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                typeString:
                  'mapping(address => struct Redemption.RedemptionSubmission)',
              },
              valueName: '',
              valueNameLocation: '-1:-1:-1',
              valueType: {
                id: 49258,
                nodeType: 'UserDefinedTypeName',
                pathNode: {
                  id: 49257,
                  name: 'RedemptionSubmission',
                  nameLocations: ['1169:20:44'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 49255,
                  src: '1169:20:44',
                },
                referencedDeclaration: 49255,
                src: '1169:20:44',
                typeDescriptions: {
                  typeIdentifier:
                    't_struct$_RedemptionSubmission_$49255_storage_ptr',
                  typeString: 'struct Redemption.RedemptionSubmission',
                },
              },
            },
            visibility: 'private',
          },
          {
            id: 49288,
            nodeType: 'FunctionDefinition',
            src: '1228:279:44',
            nodes: [],
            body: {
              id: 49287,
              nodeType: 'Block',
              src: '1344:163:44',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 49273,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 49269,
                      name: '_rdao',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49221,
                      src: '1354:5:44',
                      typeDescriptions: {
                        typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                        typeString: 'contract RegionalDaoToken',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      arguments: [
                        {
                          id: 49271,
                          name: '_rdaoAddress',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49262,
                          src: '1379:12:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        ],
                        id: 49270,
                        name: 'RegionalDaoToken',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50188,
                        src: '1362:16:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_type$_t_contract$_RegionalDaoToken_$50188_$',
                          typeString: 'type(contract RegionalDaoToken)',
                        },
                      },
                      id: 49272,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: 'typeConversion',
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: 'FunctionCall',
                      src: '1362:30:44',
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                        typeString: 'contract RegionalDaoToken',
                      },
                    },
                    src: '1354:38:44',
                    typeDescriptions: {
                      typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                      typeString: 'contract RegionalDaoToken',
                    },
                  },
                  id: 49274,
                  nodeType: 'ExpressionStatement',
                  src: '1354:38:44',
                },
                {
                  expression: {
                    id: 49279,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 49275,
                      name: '_usdt',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49224,
                      src: '1402:5:44',
                      typeDescriptions: {
                        typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                        typeString: 'contract RegionalDaoToken',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      arguments: [
                        {
                          id: 49277,
                          name: '_usdtAddress',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49264,
                          src: '1427:12:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        ],
                        id: 49276,
                        name: 'RegionalDaoToken',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50188,
                        src: '1410:16:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_type$_t_contract$_RegionalDaoToken_$50188_$',
                          typeString: 'type(contract RegionalDaoToken)',
                        },
                      },
                      id: 49278,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: 'typeConversion',
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: 'FunctionCall',
                      src: '1410:30:44',
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                        typeString: 'contract RegionalDaoToken',
                      },
                    },
                    src: '1402:38:44',
                    typeDescriptions: {
                      typeIdentifier: 't_contract$_RegionalDaoToken_$50188',
                      typeString: 'contract RegionalDaoToken',
                    },
                  },
                  id: 49280,
                  nodeType: 'ExpressionStatement',
                  src: '1402:38:44',
                },
                {
                  expression: {
                    id: 49285,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 49281,
                      name: '_verification',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49218,
                      src: '1450:13:44',
                      typeDescriptions: {
                        typeIdentifier: 't_contract$_Verification_$50009',
                        typeString: 'contract Verification',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      arguments: [
                        {
                          id: 49283,
                          name: '_verificationAddress',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49266,
                          src: '1479:20:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        ],
                        id: 49282,
                        name: 'Verification',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50009,
                        src: '1466:12:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_type$_t_contract$_Verification_$50009_$',
                          typeString: 'type(contract Verification)',
                        },
                      },
                      id: 49284,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: 'typeConversion',
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: 'FunctionCall',
                      src: '1466:34:44',
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: 't_contract$_Verification_$50009',
                        typeString: 'contract Verification',
                      },
                    },
                    src: '1450:50:44',
                    typeDescriptions: {
                      typeIdentifier: 't_contract$_Verification_$50009',
                      typeString: 'contract Verification',
                    },
                  },
                  id: 49286,
                  nodeType: 'ExpressionStatement',
                  src: '1450:50:44',
                },
              ],
            },
            implemented: true,
            kind: 'constructor',
            modifiers: [],
            name: '',
            nameLocation: '-1:-1:-1',
            parameters: {
              id: 49267,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49262,
                  mutability: 'mutable',
                  name: '_rdaoAddress',
                  nameLocation: '1257:12:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49288,
                  src: '1249:20:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49261,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '1249:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49264,
                  mutability: 'mutable',
                  name: '_usdtAddress',
                  nameLocation: '1287:12:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49288,
                  src: '1279:20:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49263,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '1279:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49266,
                  mutability: 'mutable',
                  name: '_verificationAddress',
                  nameLocation: '1317:20:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49288,
                  src: '1309:28:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49265,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '1309:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1239:104:44',
            },
            returnParameters: {
              id: 49268,
              nodeType: 'ParameterList',
              parameters: [],
              src: '1344:0:44',
            },
            scope: 49561,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 49301,
            nodeType: 'FunctionDefinition',
            src: '1513:149:44',
            nodes: [],
            body: {
              id: 49300,
              nodeType: 'Block',
              src: '1610:52:44',
              nodes: [],
              statements: [
                {
                  expression: {
                    baseExpression: {
                      id: 49296,
                      name: '_redemptionSubmissions',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49260,
                      src: '1627:22:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                        typeString:
                          'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                      },
                    },
                    id: 49298,
                    indexExpression: {
                      id: 49297,
                      name: 'user',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49290,
                      src: '1650:4:44',
                      typeDescriptions: {
                        typeIdentifier: 't_address',
                        typeString: 'address',
                      },
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: 'IndexAccess',
                    src: '1627:28:44',
                    typeDescriptions: {
                      typeIdentifier:
                        't_struct$_RedemptionSubmission_$49255_storage',
                      typeString:
                        'struct Redemption.RedemptionSubmission storage ref',
                    },
                  },
                  functionReturnParameters: 49295,
                  id: 49299,
                  nodeType: 'Return',
                  src: '1620:35:44',
                },
              ],
            },
            functionSelector: '30ccebb5',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'getStatus',
            nameLocation: '1522:9:44',
            parameters: {
              id: 49291,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49290,
                  mutability: 'mutable',
                  name: 'user',
                  nameLocation: '1549:4:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49301,
                  src: '1541:12:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49289,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '1541:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1531:28:44',
            },
            returnParameters: {
              id: 49295,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49294,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 49301,
                  src: '1581:27:44',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier:
                      't_struct$_RedemptionSubmission_$49255_memory_ptr',
                    typeString: 'struct Redemption.RedemptionSubmission',
                  },
                  typeName: {
                    id: 49293,
                    nodeType: 'UserDefinedTypeName',
                    pathNode: {
                      id: 49292,
                      name: 'RedemptionSubmission',
                      nameLocations: ['1581:20:44'],
                      nodeType: 'IdentifierPath',
                      referencedDeclaration: 49255,
                      src: '1581:20:44',
                    },
                    referencedDeclaration: 49255,
                    src: '1581:20:44',
                    typeDescriptions: {
                      typeIdentifier:
                        't_struct$_RedemptionSubmission_$49255_storage_ptr',
                      typeString: 'struct Redemption.RedemptionSubmission',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1580:29:44',
            },
            scope: 49561,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 49351,
            nodeType: 'FunctionDefinition',
            src: '1668:641:44',
            nodes: [],
            body: {
              id: 49350,
              nodeType: 'Block',
              src: '1720:589:44',
              nodes: [],
              statements: [
                {
                  assignments: [49307],
                  declarations: [
                    {
                      constant: false,
                      id: 49307,
                      mutability: 'mutable',
                      name: 'usdtAmt',
                      nameLocation: '1738:7:44',
                      nodeType: 'VariableDeclaration',
                      scope: 49350,
                      src: '1730:15:44',
                      stateVariable: false,
                      storageLocation: 'default',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                      typeName: {
                        id: 49306,
                        name: 'uint256',
                        nodeType: 'ElementaryTypeName',
                        src: '1730:7:44',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                      visibility: 'internal',
                    },
                  ],
                  id: 49309,
                  initialValue: {
                    id: 49308,
                    name: 'daoTokenAmount',
                    nodeType: 'Identifier',
                    overloadedDeclarations: [],
                    referencedDeclaration: 49303,
                    src: '1748:14:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  nodeType: 'VariableDeclarationStatement',
                  src: '1730:32:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 49313,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '1815:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49314,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '1819:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '1815:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          {
                            id: 49315,
                            name: 'usdtAmt',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49307,
                            src: '1827:7:44',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                            {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          ],
                          expression: {
                            id: 49311,
                            name: '_verification',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49218,
                            src: '1793:13:44',
                            typeDescriptions: {
                              typeIdentifier: 't_contract$_Verification_$50009',
                              typeString: 'contract Verification',
                            },
                          },
                          id: 49312,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '1807:7:44',
                          memberName: 'isValid',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49862,
                          src: '1793:21:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_function_external_view$_t_address_$_t_uint256_$returns$_t_bool_$',
                            typeString:
                              'function (address,uint256) view external returns (bool)',
                          },
                        },
                        id: 49316,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: 'functionCall',
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: 'FunctionCall',
                        src: '1793:42:44',
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '5472616e73616374696f6e206973206e6f742076616c6964',
                        id: 49317,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '1849:26:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_42439d1523da38dcb08185c2b09b97b2a2a3ecda97da992a4f9a0bd6c6cdde30',
                          typeString:
                            'literal_string "Transaction is not valid"',
                        },
                        value: 'Transaction is not valid',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_42439d1523da38dcb08185c2b09b97b2a2a3ecda97da992a4f9a0bd6c6cdde30',
                          typeString:
                            'literal_string "Transaction is not valid"',
                        },
                      ],
                      id: 49310,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '1772:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49318,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '1772:113:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49319,
                  nodeType: 'ExpressionStatement',
                  src: '1772:113:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 49327,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 49321,
                              name: '_redemptionSubmissions',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49260,
                              src: '1917:22:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                typeString:
                                  'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                              },
                            },
                            id: 49324,
                            indexExpression: {
                              expression: {
                                id: 49322,
                                name: 'msg',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: '1940:3:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_magic_message',
                                  typeString: 'msg',
                                },
                              },
                              id: 49323,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: '1944:6:44',
                              memberName: 'sender',
                              nodeType: 'MemberAccess',
                              src: '1940:10:44',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '1917:34:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_RedemptionSubmission_$49255_storage',
                              typeString:
                                'struct Redemption.RedemptionSubmission storage ref',
                            },
                          },
                          id: 49325,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '1952:6:44',
                          memberName: 'status',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49254,
                          src: '1917:41:44',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '==',
                        rightExpression: {
                          hexValue: '30',
                          id: 49326,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: 'number',
                          lValueRequested: false,
                          nodeType: 'Literal',
                          src: '1962:1:44',
                          typeDescriptions: {
                            typeIdentifier: 't_rational_0_by_1',
                            typeString: 'int_const 0',
                          },
                          value: '0',
                        },
                        src: '1917:46:44',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '526564656d7074696f6e20616c726561647920696e2070726f6772657373',
                        id: 49328,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '1977:32:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_25629716b0596c667a5dfb7774ff034d84750e5a62d8a08e572e0500ae0ea9d2',
                          typeString:
                            'literal_string "Redemption already in progress"',
                        },
                        value: 'Redemption already in progress',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_25629716b0596c667a5dfb7774ff034d84750e5a62d8a08e572e0500ae0ea9d2',
                          typeString:
                            'literal_string "Redemption already in progress"',
                        },
                      ],
                      id: 49320,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '1896:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49329,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '1896:123:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49330,
                  nodeType: 'ExpressionStatement',
                  src: '1896:123:44',
                },
                {
                  expression: {
                    id: 49341,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 49331,
                        name: '_redemptionSubmissions',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 49260,
                        src: '2030:22:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                          typeString:
                            'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                        },
                      },
                      id: 49334,
                      indexExpression: {
                        expression: {
                          id: 49332,
                          name: 'msg',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: '2053:3:44',
                          typeDescriptions: {
                            typeIdentifier: 't_magic_message',
                            typeString: 'msg',
                          },
                        },
                        id: 49333,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '2057:6:44',
                        memberName: 'sender',
                        nodeType: 'MemberAccess',
                        src: '2053:10:44',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: 'IndexAccess',
                      src: '2030:34:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_struct$_RedemptionSubmission_$49255_storage',
                        typeString:
                          'struct Redemption.RedemptionSubmission storage ref',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      components: [
                        {
                          arguments: [
                            {
                              id: 49336,
                              name: 'usdtAmt',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49307,
                              src: '2129:7:44',
                              typeDescriptions: {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256',
                              },
                            },
                            {
                              id: 49337,
                              name: 'daoTokenAmount',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49303,
                              src: '2164:14:44',
                              typeDescriptions: {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256',
                              },
                            },
                            {
                              hexValue: '31',
                              id: 49338,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: 'number',
                              lValueRequested: false,
                              nodeType: 'Literal',
                              src: '2204:1:44',
                              typeDescriptions: {
                                typeIdentifier: 't_rational_1_by_1',
                                typeString: 'int_const 1',
                              },
                              value: '1',
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256',
                              },
                              {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256',
                              },
                              {
                                typeIdentifier: 't_rational_1_by_1',
                                typeString: 'int_const 1',
                              },
                            ],
                            id: 49335,
                            name: 'RedemptionSubmission',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49255,
                            src: '2081:20:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_type$_t_struct$_RedemptionSubmission_$49255_storage_ptr_$',
                              typeString:
                                'type(struct Redemption.RedemptionSubmission storage pointer)',
                            },
                          },
                          id: 49339,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: 'structConstructorCall',
                          lValueRequested: false,
                          nameLocations: [
                            '2120:7:44',
                            '2154:8:44',
                            '2196:6:44',
                          ],
                          names: ['usdtAmt', 'tokenAmt', 'status'],
                          nodeType: 'FunctionCall',
                          src: '2081:139:44',
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_RedemptionSubmission_$49255_memory_ptr',
                            typeString:
                              'struct Redemption.RedemptionSubmission memory',
                          },
                        },
                      ],
                      id: 49340,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: 'TupleExpression',
                      src: '2067:163:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_struct$_RedemptionSubmission_$49255_memory_ptr',
                        typeString:
                          'struct Redemption.RedemptionSubmission memory',
                      },
                    },
                    src: '2030:200:44',
                    typeDescriptions: {
                      typeIdentifier:
                        't_struct$_RedemptionSubmission_$49255_storage',
                      typeString:
                        'struct Redemption.RedemptionSubmission storage ref',
                    },
                  },
                  id: 49342,
                  nodeType: 'ExpressionStatement',
                  src: '2030:200:44',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        expression: {
                          id: 49344,
                          name: 'msg',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: '2266:3:44',
                          typeDescriptions: {
                            typeIdentifier: 't_magic_message',
                            typeString: 'msg',
                          },
                        },
                        id: 49345,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '2270:6:44',
                        memberName: 'sender',
                        nodeType: 'MemberAccess',
                        src: '2266:10:44',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        id: 49346,
                        name: 'daoTokenAmount',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 49303,
                        src: '2278:14:44',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                      {
                        id: 49347,
                        name: 'usdtAmt',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 49307,
                        src: '2294:7:44',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      ],
                      id: 49343,
                      name: 'RedemptionSubmitted',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49232,
                      src: '2246:19:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$',
                        typeString: 'function (address,uint256,uint256)',
                      },
                    },
                    id: 49348,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2246:56:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49349,
                  nodeType: 'EmitStatement',
                  src: '2241:61:44',
                },
              ],
            },
            functionSelector: '013054c2',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'redeemToken',
            nameLocation: '1677:11:44',
            parameters: {
              id: 49304,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49303,
                  mutability: 'mutable',
                  name: 'daoTokenAmount',
                  nameLocation: '1697:14:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49351,
                  src: '1689:22:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49302,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '1689:7:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1688:24:44',
            },
            returnParameters: {
              id: 49305,
              nodeType: 'ParameterList',
              parameters: [],
              src: '1720:0:44',
            },
            scope: 49561,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 49390,
            nodeType: 'FunctionDefinition',
            src: '2315:410:44',
            nodes: [],
            body: {
              id: 49389,
              nodeType: 'Block',
              src: '2373:352:44',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 49364,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 49359,
                              name: '_redemptionSubmissions',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49260,
                              src: '2404:22:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                typeString:
                                  'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                              },
                            },
                            id: 49361,
                            indexExpression: {
                              id: 49360,
                              name: 'user',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49353,
                              src: '2427:4:44',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '2404:28:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_RedemptionSubmission_$49255_storage',
                              typeString:
                                'struct Redemption.RedemptionSubmission storage ref',
                            },
                          },
                          id: 49362,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '2433:6:44',
                          memberName: 'status',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49254,
                          src: '2404:35:44',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '!=',
                        rightExpression: {
                          hexValue: '30',
                          id: 49363,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: 'number',
                          lValueRequested: false,
                          nodeType: 'Literal',
                          src: '2443:1:44',
                          typeDescriptions: {
                            typeIdentifier: 't_rational_0_by_1',
                            typeString: 'int_const 0',
                          },
                          value: '0',
                        },
                        src: '2404:40:44',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '526564656d7074696f6e206e6f20726564656d7074696f6e20726571756573746564',
                        id: 49365,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '2458:36:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_206377309d70cf2adff9ed66852453bcc065ef6df66b0191ec969a9f62ad6f26',
                          typeString:
                            'literal_string "Redemption no redemption requested"',
                        },
                        value: 'Redemption no redemption requested',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_206377309d70cf2adff9ed66852453bcc065ef6df66b0191ec969a9f62ad6f26',
                          typeString:
                            'literal_string "Redemption no redemption requested"',
                        },
                      ],
                      id: 49358,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '2383:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49366,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2383:121:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49367,
                  nodeType: 'ExpressionStatement',
                  src: '2383:121:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 49374,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 49369,
                              name: '_redemptionSubmissions',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49260,
                              src: '2535:22:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                typeString:
                                  'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                              },
                            },
                            id: 49371,
                            indexExpression: {
                              id: 49370,
                              name: 'user',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49353,
                              src: '2558:4:44',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '2535:28:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_RedemptionSubmission_$49255_storage',
                              typeString:
                                'struct Redemption.RedemptionSubmission storage ref',
                            },
                          },
                          id: 49372,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '2564:6:44',
                          memberName: 'status',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49254,
                          src: '2535:35:44',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '!=',
                        rightExpression: {
                          hexValue: '32',
                          id: 49373,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: 'number',
                          lValueRequested: false,
                          nodeType: 'Literal',
                          src: '2574:1:44',
                          typeDescriptions: {
                            typeIdentifier: 't_rational_2_by_1',
                            typeString: 'int_const 2',
                          },
                          value: '2',
                        },
                        src: '2535:40:44',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '526564656d7074696f6e20616c726561647920617070726f766564',
                        id: 49375,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '2589:29:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_0abdf7ad2f9c28d33853c11e173eb77b34aa0cff9c9c4ef539fd7a0cd1b8d8f3',
                          typeString:
                            'literal_string "Redemption already approved"',
                        },
                        value: 'Redemption already approved',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_0abdf7ad2f9c28d33853c11e173eb77b34aa0cff9c9c4ef539fd7a0cd1b8d8f3',
                          typeString:
                            'literal_string "Redemption already approved"',
                        },
                      ],
                      id: 49368,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '2514:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49376,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2514:114:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49377,
                  nodeType: 'ExpressionStatement',
                  src: '2514:114:44',
                },
                {
                  expression: {
                    id: 49383,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49378,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '2639:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49380,
                        indexExpression: {
                          id: 49379,
                          name: 'user',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49353,
                          src: '2662:4:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2639:28:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49381,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '2668:6:44',
                      memberName: 'status',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49254,
                      src: '2639:35:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '32',
                      id: 49382,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '2677:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_2_by_1',
                        typeString: 'int_const 2',
                      },
                      value: '2',
                    },
                    src: '2639:39:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49384,
                  nodeType: 'ExpressionStatement',
                  src: '2639:39:44',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 49386,
                        name: 'user',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 49353,
                        src: '2713:4:44',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      ],
                      id: 49385,
                      name: 'RedemptionApproved',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49236,
                      src: '2694:18:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$returns$__$',
                        typeString: 'function (address)',
                      },
                    },
                    id: 49387,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2694:24:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49388,
                  nodeType: 'EmitStatement',
                  src: '2689:29:44',
                },
              ],
            },
            functionSelector: '711a5c86',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 49356,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 49355,
                  name: 'onlyOwner',
                  nameLocations: ['2363:9:44'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43419,
                  src: '2363:9:44',
                },
                nodeType: 'ModifierInvocation',
                src: '2363:9:44',
              },
            ],
            name: 'approveRedemption',
            nameLocation: '2324:17:44',
            parameters: {
              id: 49354,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49353,
                  mutability: 'mutable',
                  name: 'user',
                  nameLocation: '2350:4:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49390,
                  src: '2342:12:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49352,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '2342:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2341:14:44',
            },
            returnParameters: {
              id: 49357,
              nodeType: 'ParameterList',
              parameters: [],
              src: '2373:0:44',
            },
            scope: 49561,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 49431,
            nodeType: 'FunctionDefinition',
            src: '2731:283:44',
            nodes: [],
            body: {
              id: 49430,
              nodeType: 'Block',
              src: '2778:236:44',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        id: 49405,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          commonType: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                          id: 49400,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              id: 49396,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '2796:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49397,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '2800:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '2796:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          nodeType: 'BinaryOperation',
                          operator: '==',
                          rightExpression: {
                            arguments: [],
                            expression: {
                              argumentTypes: [],
                              id: 49398,
                              name: 'owner',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 43428,
                              src: '2810:5:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_function_internal_view$__$returns$_t_address_$',
                                typeString:
                                  'function () view returns (address)',
                              },
                            },
                            id: 49399,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: 'functionCall',
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: 'FunctionCall',
                            src: '2810:7:44',
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          src: '2796:21:44',
                          typeDescriptions: {
                            typeIdentifier: 't_bool',
                            typeString: 'bool',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '||',
                        rightExpression: {
                          commonType: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                          id: 49404,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              id: 49401,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '2821:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49402,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '2825:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '2821:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          nodeType: 'BinaryOperation',
                          operator: '==',
                          rightExpression: {
                            id: 49403,
                            name: 'user',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49392,
                            src: '2835:4:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          src: '2821:18:44',
                          typeDescriptions: {
                            typeIdentifier: 't_bool',
                            typeString: 'bool',
                          },
                        },
                        src: '2796:43:44',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue: '556e617574686f72697a6564',
                        id: 49406,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '2841:14:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_1b2638459828301e8cd6c7c02856073bacf975379e0867f689bb14feacb780c5',
                          typeString: 'literal_string "Unauthorized"',
                        },
                        value: 'Unauthorized',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_1b2638459828301e8cd6c7c02856073bacf975379e0867f689bb14feacb780c5',
                          typeString: 'literal_string "Unauthorized"',
                        },
                      ],
                      id: 49395,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '2788:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49407,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2788:68:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49408,
                  nodeType: 'ExpressionStatement',
                  src: '2788:68:44',
                },
                {
                  expression: {
                    id: 49414,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49409,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '2867:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49411,
                        indexExpression: {
                          id: 49410,
                          name: 'user',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49392,
                          src: '2890:4:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2867:28:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49412,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '2896:6:44',
                      memberName: 'status',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49254,
                      src: '2867:35:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 49413,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '2905:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '2867:39:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49415,
                  nodeType: 'ExpressionStatement',
                  src: '2867:39:44',
                },
                {
                  expression: {
                    id: 49421,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49416,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '2916:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49418,
                        indexExpression: {
                          id: 49417,
                          name: 'user',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49392,
                          src: '2939:4:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2916:28:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49419,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '2945:8:44',
                      memberName: 'tokenAmt',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49250,
                      src: '2916:37:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 49420,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '2956:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '2916:41:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49422,
                  nodeType: 'ExpressionStatement',
                  src: '2916:41:44',
                },
                {
                  expression: {
                    id: 49428,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49423,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '2967:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49425,
                        indexExpression: {
                          id: 49424,
                          name: 'user',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49392,
                          src: '2990:4:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2967:28:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49426,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '2996:7:44',
                      memberName: 'usdtAmt',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49252,
                      src: '2967:36:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 49427,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '3006:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '2967:40:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49429,
                  nodeType: 'ExpressionStatement',
                  src: '2967:40:44',
                },
              ],
            },
            functionSelector: '92dd9f88',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'rejectRedemption',
            nameLocation: '2740:16:44',
            parameters: {
              id: 49393,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49392,
                  mutability: 'mutable',
                  name: 'user',
                  nameLocation: '2765:4:44',
                  nodeType: 'VariableDeclaration',
                  scope: 49431,
                  src: '2757:12:44',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49391,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '2757:7:44',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2756:14:44',
            },
            returnParameters: {
              id: 49394,
              nodeType: 'ParameterList',
              parameters: [],
              src: '2778:0:44',
            },
            scope: 49561,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 49560,
            nodeType: 'FunctionDefinition',
            src: '3020:1557:44',
            nodes: [],
            body: {
              id: 49559,
              nodeType: 'Block',
              src: '3057:1520:44',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 49441,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 49435,
                              name: '_redemptionSubmissions',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49260,
                              src: '3088:22:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                typeString:
                                  'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                              },
                            },
                            id: 49438,
                            indexExpression: {
                              expression: {
                                id: 49436,
                                name: 'msg',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: '3111:3:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_magic_message',
                                  typeString: 'msg',
                                },
                              },
                              id: 49437,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: '3115:6:44',
                              memberName: 'sender',
                              nodeType: 'MemberAccess',
                              src: '3111:10:44',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '3088:34:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_RedemptionSubmission_$49255_storage',
                              typeString:
                                'struct Redemption.RedemptionSubmission storage ref',
                            },
                          },
                          id: 49439,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '3123:6:44',
                          memberName: 'status',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49254,
                          src: '3088:41:44',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '==',
                        rightExpression: {
                          hexValue: '32',
                          id: 49440,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: 'number',
                          lValueRequested: false,
                          nodeType: 'Literal',
                          src: '3133:1:44',
                          typeDescriptions: {
                            typeIdentifier: 't_rational_2_by_1',
                            typeString: 'int_const 2',
                          },
                          value: '2',
                        },
                        src: '3088:46:44',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '546f6b656e20726564656d7074696f6e206177616974696e6720617070726f76616c',
                        id: 49442,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3148:36:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_e025671a1ec93b317fb47a46f3f43411fb18df5b98aa43308f3d811c315020c4',
                          typeString:
                            'literal_string "Token redemption awaiting approval"',
                        },
                        value: 'Token redemption awaiting approval',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_e025671a1ec93b317fb47a46f3f43411fb18df5b98aa43308f3d811c315020c4',
                          typeString:
                            'literal_string "Token redemption awaiting approval"',
                        },
                      ],
                      id: 49434,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3067:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49443,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3067:127:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49444,
                  nodeType: 'ExpressionStatement',
                  src: '3067:127:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 49458,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  id: 49450,
                                  name: 'this',
                                  nodeType: 'Identifier',
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: '3250:4:44',
                                  typeDescriptions: {
                                    typeIdentifier:
                                      't_contract$_Redemption_$49561',
                                    typeString: 'contract Redemption',
                                  },
                                },
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier:
                                      't_contract$_Redemption_$49561',
                                    typeString: 'contract Redemption',
                                  },
                                ],
                                id: 49449,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: 'ElementaryTypeNameExpression',
                                src: '3242:7:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_type$_t_address_$',
                                  typeString: 'type(address)',
                                },
                                typeName: {
                                  id: 49448,
                                  name: 'address',
                                  nodeType: 'ElementaryTypeName',
                                  src: '3242:7:44',
                                  typeDescriptions: {},
                                },
                              },
                              id: 49451,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: 'typeConversion',
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: 'FunctionCall',
                              src: '3242:13:44',
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            ],
                            expression: {
                              id: 49446,
                              name: '_usdt',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49224,
                              src: '3226:5:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_contract$_RegionalDaoToken_$50188',
                                typeString: 'contract RegionalDaoToken',
                              },
                            },
                            id: 49447,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3232:9:44',
                            memberName: 'balanceOf',
                            nodeType: 'MemberAccess',
                            referencedDeclaration: 43834,
                            src: '3226:15:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_function_external_view$_t_address_$returns$_t_uint256_$',
                              typeString:
                                'function (address) view external returns (uint256)',
                            },
                          },
                          id: 49452,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: 'functionCall',
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: 'FunctionCall',
                          src: '3226:30:44',
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '>=',
                        rightExpression: {
                          expression: {
                            baseExpression: {
                              id: 49453,
                              name: '_redemptionSubmissions',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 49260,
                              src: '3276:22:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                typeString:
                                  'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                              },
                            },
                            id: 49456,
                            indexExpression: {
                              expression: {
                                id: 49454,
                                name: 'msg',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: '3299:3:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_magic_message',
                                  typeString: 'msg',
                                },
                              },
                              id: 49455,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: '3303:6:44',
                              memberName: 'sender',
                              nodeType: 'MemberAccess',
                              src: '3299:10:44',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '3276:34:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_RedemptionSubmission_$49255_storage',
                              typeString:
                                'struct Redemption.RedemptionSubmission storage ref',
                            },
                          },
                          id: 49457,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '3311:7:44',
                          memberName: 'usdtAmt',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49252,
                          src: '3276:42:44',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        src: '3226:92:44',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '496e73756666696369656e7420555344542062616c616e6365206f6e20636f6e7472616374',
                        id: 49459,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3332:39:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_3cfade7c432f387eb8e430823ed45f1ceda54b78306d0b7640c82caf075c4834',
                          typeString:
                            'literal_string "Insufficient USDT balance on contract"',
                        },
                        value: 'Insufficient USDT balance on contract',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_3cfade7c432f387eb8e430823ed45f1ceda54b78306d0b7640c82caf075c4834',
                          typeString:
                            'literal_string "Insufficient USDT balance on contract"',
                        },
                      ],
                      id: 49445,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3205:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49460,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3205:176:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49461,
                  nodeType: 'ExpressionStatement',
                  src: '3205:176:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 49465,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '3452:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49466,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3456:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '3452:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          {
                            expression: {
                              baseExpression: {
                                id: 49467,
                                name: '_redemptionSubmissions',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 49260,
                                src: '3480:22:44',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                  typeString:
                                    'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                                },
                              },
                              id: 49470,
                              indexExpression: {
                                expression: {
                                  id: 49468,
                                  name: 'msg',
                                  nodeType: 'Identifier',
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -15,
                                  src: '3503:3:44',
                                  typeDescriptions: {
                                    typeIdentifier: 't_magic_message',
                                    typeString: 'msg',
                                  },
                                },
                                id: 49469,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: '3507:6:44',
                                memberName: 'sender',
                                nodeType: 'MemberAccess',
                                src: '3503:10:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_address',
                                  typeString: 'address',
                                },
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: 'IndexAccess',
                              src: '3480:34:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_struct$_RedemptionSubmission_$49255_storage',
                                typeString:
                                  'struct Redemption.RedemptionSubmission storage ref',
                              },
                            },
                            id: 49471,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3515:7:44',
                            memberName: 'usdtAmt',
                            nodeType: 'MemberAccess',
                            referencedDeclaration: 49252,
                            src: '3480:42:44',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                            {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          ],
                          expression: {
                            id: 49463,
                            name: '_verification',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49218,
                            src: '3413:13:44',
                            typeDescriptions: {
                              typeIdentifier: 't_contract$_Verification_$50009',
                              typeString: 'contract Verification',
                            },
                          },
                          id: 49464,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '3427:7:44',
                          memberName: 'isValid',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 49862,
                          src: '3413:21:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_function_external_view$_t_address_$_t_uint256_$returns$_t_bool_$',
                            typeString:
                              'function (address,uint256) view external returns (bool)',
                          },
                        },
                        id: 49472,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: 'functionCall',
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: 'FunctionCall',
                        src: '3413:123:44',
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '4661696c656420746f2066696e616c697a6520726564656d7074696f6e',
                        id: 49473,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3550:31:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_535d705dc7a3e75cf52c6fa5c68e959f2870ff0390fa854a2c81f0b0f5e2f75e',
                          typeString:
                            'literal_string "Failed to finalize redemption"',
                        },
                        value: 'Failed to finalize redemption',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_535d705dc7a3e75cf52c6fa5c68e959f2870ff0390fa854a2c81f0b0f5e2f75e',
                          typeString:
                            'literal_string "Failed to finalize redemption"',
                        },
                      ],
                      id: 49462,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3392:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49474,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3392:199:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49475,
                  nodeType: 'ExpressionStatement',
                  src: '3392:199:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 49479,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '3655:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49480,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3659:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '3655:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          {
                            expression: {
                              baseExpression: {
                                id: 49481,
                                name: '_redemptionSubmissions',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 49260,
                                src: '3683:22:44',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                  typeString:
                                    'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                                },
                              },
                              id: 49484,
                              indexExpression: {
                                expression: {
                                  id: 49482,
                                  name: 'msg',
                                  nodeType: 'Identifier',
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -15,
                                  src: '3706:3:44',
                                  typeDescriptions: {
                                    typeIdentifier: 't_magic_message',
                                    typeString: 'msg',
                                  },
                                },
                                id: 49483,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: '3710:6:44',
                                memberName: 'sender',
                                nodeType: 'MemberAccess',
                                src: '3706:10:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_address',
                                  typeString: 'address',
                                },
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: 'IndexAccess',
                              src: '3683:34:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_struct$_RedemptionSubmission_$49255_storage',
                                typeString:
                                  'struct Redemption.RedemptionSubmission storage ref',
                              },
                            },
                            id: 49485,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3718:7:44',
                            memberName: 'usdtAmt',
                            nodeType: 'MemberAccess',
                            referencedDeclaration: 49252,
                            src: '3683:42:44',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                            {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          ],
                          expression: {
                            id: 49477,
                            name: '_usdt',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49224,
                            src: '3623:5:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_contract$_RegionalDaoToken_$50188',
                              typeString: 'contract RegionalDaoToken',
                            },
                          },
                          id: 49478,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '3629:8:44',
                          memberName: 'transfer',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 43859,
                          src: '3623:14:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$',
                            typeString:
                              'function (address,uint256) external returns (bool)',
                          },
                        },
                        id: 49486,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: 'functionCall',
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: 'FunctionCall',
                        src: '3623:116:44',
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue: '55534454207472616e73666572206661696c6564',
                        id: 49487,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3753:22:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_b3295075fa7fca4b40bbe643670df8daec732e3f637bee98813a2a9d48dabed4',
                          typeString: 'literal_string "USDT transfer failed"',
                        },
                        value: 'USDT transfer failed',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_b3295075fa7fca4b40bbe643670df8daec732e3f637bee98813a2a9d48dabed4',
                          typeString: 'literal_string "USDT transfer failed"',
                        },
                      ],
                      id: 49476,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3602:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49488,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3602:183:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49489,
                  nodeType: 'ExpressionStatement',
                  src: '3602:183:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 49493,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '3919:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49494,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3923:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '3919:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          {
                            arguments: [
                              {
                                id: 49497,
                                name: 'this',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: -28,
                                src: '3955:4:44',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_contract$_Redemption_$49561',
                                  typeString: 'contract Redemption',
                                },
                              },
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier:
                                    't_contract$_Redemption_$49561',
                                  typeString: 'contract Redemption',
                                },
                              ],
                              id: 49496,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: 'ElementaryTypeNameExpression',
                              src: '3947:7:44',
                              typeDescriptions: {
                                typeIdentifier: 't_type$_t_address_$',
                                typeString: 'type(address)',
                              },
                              typeName: {
                                id: 49495,
                                name: 'address',
                                nodeType: 'ElementaryTypeName',
                                src: '3947:7:44',
                                typeDescriptions: {},
                              },
                            },
                            id: 49498,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: 'typeConversion',
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: 'FunctionCall',
                            src: '3947:13:44',
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          {
                            expression: {
                              baseExpression: {
                                id: 49499,
                                name: '_redemptionSubmissions',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 49260,
                                src: '3978:22:44',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                                  typeString:
                                    'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                                },
                              },
                              id: 49502,
                              indexExpression: {
                                expression: {
                                  id: 49500,
                                  name: 'msg',
                                  nodeType: 'Identifier',
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -15,
                                  src: '4001:3:44',
                                  typeDescriptions: {
                                    typeIdentifier: 't_magic_message',
                                    typeString: 'msg',
                                  },
                                },
                                id: 49501,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: '4005:6:44',
                                memberName: 'sender',
                                nodeType: 'MemberAccess',
                                src: '4001:10:44',
                                typeDescriptions: {
                                  typeIdentifier: 't_address',
                                  typeString: 'address',
                                },
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: 'IndexAccess',
                              src: '3978:34:44',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_struct$_RedemptionSubmission_$49255_storage',
                                typeString:
                                  'struct Redemption.RedemptionSubmission storage ref',
                              },
                            },
                            id: 49503,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '4013:8:44',
                            memberName: 'tokenAmt',
                            nodeType: 'MemberAccess',
                            referencedDeclaration: 49250,
                            src: '3978:43:44',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                            {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                            {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          ],
                          expression: {
                            id: 49491,
                            name: '_rdao',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49221,
                            src: '3883:5:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_contract$_RegionalDaoToken_$50188',
                              typeString: 'contract RegionalDaoToken',
                            },
                          },
                          id: 49492,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '3889:12:44',
                          memberName: 'transferFrom',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 43935,
                          src: '3883:18:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$',
                            typeString:
                              'function (address,address,uint256) external returns (bool)',
                          },
                        },
                        id: 49504,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: 'functionCall',
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: 'FunctionCall',
                        src: '3883:152:44',
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue: '5244414f207472616e73666572206661696c6564',
                        id: 49505,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '4049:22:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_eb3db93ceb173c0472fae47fcd5df4e97e552ec95bfae526b3aaf08f97e70891',
                          typeString: 'literal_string "RDAO transfer failed"',
                        },
                        value: 'RDAO transfer failed',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_eb3db93ceb173c0472fae47fcd5df4e97e552ec95bfae526b3aaf08f97e70891',
                          typeString: 'literal_string "RDAO transfer failed"',
                        },
                      ],
                      id: 49490,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3862:7:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 49506,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3862:219:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49507,
                  nodeType: 'ExpressionStatement',
                  src: '3862:219:44',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        expression: {
                          id: 49509,
                          name: 'msg',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: '4130:3:44',
                          typeDescriptions: {
                            typeIdentifier: 't_magic_message',
                            typeString: 'msg',
                          },
                        },
                        id: 49510,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '4134:6:44',
                        memberName: 'sender',
                        nodeType: 'MemberAccess',
                        src: '4130:10:44',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        expression: {
                          baseExpression: {
                            id: 49511,
                            name: '_redemptionSubmissions',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49260,
                            src: '4154:22:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                              typeString:
                                'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                            },
                          },
                          id: 49514,
                          indexExpression: {
                            expression: {
                              id: 49512,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '4177:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49513,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '4181:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '4177:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '4154:34:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_RedemptionSubmission_$49255_storage',
                            typeString:
                              'struct Redemption.RedemptionSubmission storage ref',
                          },
                        },
                        id: 49515,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '4189:8:44',
                        memberName: 'tokenAmt',
                        nodeType: 'MemberAccess',
                        referencedDeclaration: 49250,
                        src: '4154:43:44',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                      {
                        expression: {
                          baseExpression: {
                            id: 49516,
                            name: '_redemptionSubmissions',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49260,
                            src: '4211:22:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                              typeString:
                                'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                            },
                          },
                          id: 49519,
                          indexExpression: {
                            expression: {
                              id: 49517,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '4234:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49518,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '4238:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '4234:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '4211:34:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_RedemptionSubmission_$49255_storage',
                            typeString:
                              'struct Redemption.RedemptionSubmission storage ref',
                          },
                        },
                        id: 49520,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '4246:7:44',
                        memberName: 'usdtAmt',
                        nodeType: 'MemberAccess',
                        referencedDeclaration: 49252,
                        src: '4211:42:44',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      ],
                      id: 49508,
                      name: 'RedemptionFinalized',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49248,
                      src: '4097:19:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$',
                        typeString: 'function (address,uint256,uint256)',
                      },
                    },
                    id: 49521,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '4097:166:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49522,
                  nodeType: 'EmitStatement',
                  src: '4092:171:44',
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 49526,
                          name: 'msg',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: '4325:3:44',
                          typeDescriptions: {
                            typeIdentifier: 't_magic_message',
                            typeString: 'msg',
                          },
                        },
                        id: 49527,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '4329:6:44',
                        memberName: 'sender',
                        nodeType: 'MemberAccess',
                        src: '4325:10:44',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        expression: {
                          baseExpression: {
                            id: 49528,
                            name: '_redemptionSubmissions',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 49260,
                            src: '4349:22:44',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                              typeString:
                                'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                            },
                          },
                          id: 49531,
                          indexExpression: {
                            expression: {
                              id: 49529,
                              name: 'msg',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: '4372:3:44',
                              typeDescriptions: {
                                typeIdentifier: 't_magic_message',
                                typeString: 'msg',
                              },
                            },
                            id: 49530,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '4376:6:44',
                            memberName: 'sender',
                            nodeType: 'MemberAccess',
                            src: '4372:10:44',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '4349:34:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_RedemptionSubmission_$49255_storage',
                            typeString:
                              'struct Redemption.RedemptionSubmission storage ref',
                          },
                        },
                        id: 49532,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '4384:7:44',
                        memberName: 'usdtAmt',
                        nodeType: 'MemberAccess',
                        referencedDeclaration: 49252,
                        src: '4349:42:44',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      ],
                      expression: {
                        id: 49523,
                        name: '_verification',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 49218,
                        src: '4274:13:44',
                        typeDescriptions: {
                          typeIdentifier: 't_contract$_Verification_$50009',
                          typeString: 'contract Verification',
                        },
                      },
                      id: 49525,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: '4288:23:44',
                      memberName: 'updateTotalTransactions',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49893,
                      src: '4274:37:44',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$',
                        typeString: 'function (address,uint256) external',
                      },
                    },
                    id: 49533,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '4274:127:44',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 49534,
                  nodeType: 'ExpressionStatement',
                  src: '4274:127:44',
                },
                {
                  expression: {
                    id: 49541,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49535,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '4412:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49538,
                        indexExpression: {
                          expression: {
                            id: 49536,
                            name: 'msg',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: '4435:3:44',
                            typeDescriptions: {
                              typeIdentifier: 't_magic_message',
                              typeString: 'msg',
                            },
                          },
                          id: 49537,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '4439:6:44',
                          memberName: 'sender',
                          nodeType: 'MemberAccess',
                          src: '4435:10:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '4412:34:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49539,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '4447:6:44',
                      memberName: 'status',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49254,
                      src: '4412:41:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 49540,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '4456:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '4412:45:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49542,
                  nodeType: 'ExpressionStatement',
                  src: '4412:45:44',
                },
                {
                  expression: {
                    id: 49549,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49543,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '4467:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49546,
                        indexExpression: {
                          expression: {
                            id: 49544,
                            name: 'msg',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: '4490:3:44',
                            typeDescriptions: {
                              typeIdentifier: 't_magic_message',
                              typeString: 'msg',
                            },
                          },
                          id: 49545,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '4494:6:44',
                          memberName: 'sender',
                          nodeType: 'MemberAccess',
                          src: '4490:10:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '4467:34:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49547,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '4502:8:44',
                      memberName: 'tokenAmt',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49250,
                      src: '4467:43:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 49548,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '4513:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '4467:47:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49550,
                  nodeType: 'ExpressionStatement',
                  src: '4467:47:44',
                },
                {
                  expression: {
                    id: 49557,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 49551,
                          name: '_redemptionSubmissions',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49260,
                          src: '4524:22:44',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_struct$_RedemptionSubmission_$49255_storage_$',
                            typeString:
                              'mapping(address => struct Redemption.RedemptionSubmission storage ref)',
                          },
                        },
                        id: 49554,
                        indexExpression: {
                          expression: {
                            id: 49552,
                            name: 'msg',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: '4547:3:44',
                            typeDescriptions: {
                              typeIdentifier: 't_magic_message',
                              typeString: 'msg',
                            },
                          },
                          id: 49553,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '4551:6:44',
                          memberName: 'sender',
                          nodeType: 'MemberAccess',
                          src: '4547:10:44',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '4524:34:44',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_RedemptionSubmission_$49255_storage',
                          typeString:
                            'struct Redemption.RedemptionSubmission storage ref',
                        },
                      },
                      id: 49555,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '4559:7:44',
                      memberName: 'usdtAmt',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 49252,
                      src: '4524:42:44',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 49556,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '4569:1:44',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '4524:46:44',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 49558,
                  nodeType: 'ExpressionStatement',
                  src: '4524:46:44',
                },
              ],
            },
            functionSelector: '56cee8ab',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'finalizeRedemption',
            nameLocation: '3029:18:44',
            parameters: {
              id: 49432,
              nodeType: 'ParameterList',
              parameters: [],
              src: '3047:2:44',
            },
            returnParameters: {
              id: 49433,
              nodeType: 'ParameterList',
              parameters: [],
              src: '3057:0:44',
            },
            scope: 49561,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 49212,
              name: 'Ownable',
              nameLocations: ['533:7:44'],
              nodeType: 'IdentifierPath',
              referencedDeclaration: 43500,
              src: '533:7:44',
            },
            id: 49213,
            nodeType: 'InheritanceSpecifier',
            src: '533:7:44',
          },
          {
            baseName: {
              id: 49214,
              name: 'Pausable',
              nameLocations: ['542:8:44'],
              nodeType: 'IdentifierPath',
              referencedDeclaration: 43735,
              src: '542:8:44',
            },
            id: 49215,
            nodeType: 'InheritanceSpecifier',
            src: '542:8:44',
          },
        ],
        canonicalName: 'Redemption',
        contractDependencies: [],
        contractKind: 'contract',
        fullyImplemented: true,
        linearizedBaseContracts: [49561, 43735, 43500, 45392],
        name: 'Redemption',
        nameLocation: '519:10:44',
        scope: 49562,
        usedErrors: [],
        usedEvents: [43401, 43638, 43643, 49232, 49236, 49240, 49248],
      },
    ],
    license: 'MIT',
  },
  id: 44,
}
